import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  Select,
  Divider,
  InputLabel,
  Checkbox,
  FormControlLabel,
  Button,
  Paper,
  Radio,
  createFilterOptions,
  Autocomplete,
  Dialog,
  DialogContent,
  Collapse,
} from "@mui/material";
import { Grid2 } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import { IconButton } from "@mui/material";
import {
  ClockIcon,
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
  renderTimeViewClock,
} from "@mui/x-date-pickers";
import { commonCss } from "../../../StyleConfig/CommonCss";
import TableSample from "../../../Component/TableSample";
import {
  ArrowBack,
  Clear,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Info,
  FileUploadOutlined,
  Visibility,
  DeleteOutlined,
} from "@mui/icons-material";
import moment from "moment";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import NormalTableWithRadius from "../../../Component/NormalTableWithRadius";
import { Form, Formik, ErrorMessage } from "formik";
import Loading from "../../../Component/Loading";
import { useSelector } from "react-redux";
import {
  api,
  companyInfo,
  operationMeasure,
  roleInfo,
  roleNameString,
} from "../../API/config";
import { axiosPrivate } from "../../../axios/axios";
import { toast } from "react-toastify";
import { useSearchParams } from "react-router-dom";
import * as Yup from "yup";
import ErrorProps from "../../../Component/Errorprops";
import Remark from "../../../Component/Remark";
import Confirmation from "../../../Component/Confirmation";
import RemarkTableView from "../../../Component/RemarkTableView";
import AuditLogDialog from "../../../Component/AuditLogDialog";

dayjs.extend(utc);
dayjs.extend(timezone);

const IsolationCertificate = ({
  certificateDetail,
  handleCloseClick,
  approvedData,
}) => {
  const login = useSelector((state) => state.auth.loginInfo);
  const loginRoleId = String(login.roleIds).split(",");
  const [searchParams, setSearchParams] = useSearchParams();
  const roleName = atob(searchParams.get("requestor")).toLowerCase();
  const [editableRowId, setEditableRowId] = useState(null);
  const [editableRowIdRe, setEditableRowIdRe] = useState(null);
  const [typeMeasure, setTypeMeasure] = useState([]);
  const [checked, setChecked] = useState({
    electrical: false,
    mechanical: false,
  });
  const [certificateInfo, setCertificateInfo] = useState({});
  const [auditLogOpen, setAuditLogOpen] = useState(false);
  const auditLogColumns = [
    { Header: "Reassigned From", accessor: "oldUserName" },
    { Header: "Reassigned To", accessor: "newUserName" },
    { Header: "Role", accessor: "roleName" },
    { Header: "Reassign Person", accessor: "reassignedByName" },
    { Header: "Approval User Name", accessor: "approvalUserName" },
    {
      Header: "Reassigned Date",
      accessor: "reassignedAt",
      Cell: ({ value }) =>
        value ? moment(value).format("DD/MM/YYYY HH:mm") : "",
    },
  ];
  const [approveInfo, setApproveInfo] = useState({
    engineerName: "",
    lpiName: "",
    certificateClosedName: "",
    lpiCertClosedName: "",
  });
  const [lpi, setLPI] = useState({
    lpiCom: "",
    lpiId: certificateInfo.lpiId,
  });

  const [roleAccess, setRoleAccess] = useState({
    contractStaff: false,
    engineer: false,
    lpi: false,
    lpiCertClose: false,
    lpiCertCloseReason: false,
    certClose: false,
    io: false,
    iv: false,
    reconnectionIV: false,
    reconnectionIO: false,
    technician: false,
    piContract: false,
    assignIOIV: false,
    submitButton: false,
    engineerCancel: false,
    lpiCancel: false,
    adminCancelButton: false,
  });
  const [loading, setLoading] = useState(false);

  const [isolationData, setIsolationData] = useState([
    {
      id: 1,
      rowName: "Isolation Owner",
      fieldName: "isolationOwnerId",
      Name: "",
      action: "",
      autoCom: "io",
    },
    {
      id: 2,
      rowName: "Isolation Verifier",
      fieldName: "isolationVerifierId",
      Name: "",
      action: "",
      autoCom: "iv",
    },
  ]);
  const [reconnectionData, setReconnectionData] = useState([
    {
      id: 1,
      rowName: "Isolation Owner",
      Name: "",
      action: "",
      autoCom: "reconnectionIO",
    },
    {
      id: 2,
      rowName: "Isolation Verifier",
      Name: "",
      action: "",
      autoCom: "reconnectionIV",
    },
  ]);

  const [ioData, setIOData] = useState([]);
  const [ivData, setIVData] = useState([]);
  const [autoCompleteValue, setAutoCompleteValue] = useState({
    iv: "",
    io: "",
    reconnectionIV: "",
    reconnectionIO: "",
  });
  const [closedRemark, setClosedRemark] = useState({
    PH: "",
    LPI: "",
  });
  const [deisolationBol, setDeisolationBol] = useState(false);
  const [remarkButton, setRemarkButton] = useState({
    reject: false,
    cancel: false,
    remarkOpen: false,
    adminCancel: false,
  });
  const [getMeasure, setGetMeasure] = useState([]);
  const [error, setError] = useState({});
  const fileInputRefIsolationPlan = useRef(null);
  const [confirm, setConfirm] = useState({
    submit: false,
    close: false,
    deIsolationFalse: false,
    deIsolationTrue: false,
    ioivApprove: false,
    ioivReassign: false,
    ioivReassignReconnection: false,
    reAssign: false,
    deleteAttach: false,
  });
  const [lpiData, setLpiData] = useState([]);
  const [confirmValue, setConfirmValue] = useState([]);
  const [backupValues, setBackupValues] = useState({});
  const [backupValuesRec, setbackupValuesRec] = useState({});
  const [activeTab, setActiveTab] = useState(0);
  const [adoptionHistoryList, setAdoptionHistoryList] = useState([]);
  const originalCertInfoRef = useRef(null);
  const originalRoleAccessRef = useRef(null);
  const OPTIONS_LIMIT = 10;
  const defaultFilterOptions = createFilterOptions();

  const filterOptions = (options, state) => {
    return defaultFilterOptions(options, state);
  };
  const CustomPaper = (props) => {
    return <Paper elevation={8} {...props} />;
  };

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoading(true);

    const getDataByForm = api.isolation.getDataByFormId;
    axiosPrivate
      .get(`${getDataByForm}?formId=${approvedData.id}`)
      .then((resForm) => {
        const getByKey = api.attributeValue.getByKeyName;
        axiosPrivate
          .get(`${getByKey}?keyName=SpecifyEnergyIsolated`)
          .then((res) => {
            const resData = res.data.data.filter((fil) => {
              let filterCheck = resForm.data.data.filter(
                (fill) => fill.specifyEnergyIsolatedId === fil.id,
              );
              if (filterCheck.length === 0) {
                return false;
              } else {
                return true;
              }
            });

            setGetMeasure(
              resData.map((ress) => {
                return ress.id;
              }),
            );
            setTypeMeasure(res.data.data);
          })
          .catch((e) => {
            console.log(e);
          });
      });
    const getById = api.isolation.getById;
    await axiosPrivate
      .get(`${getById}/${certificateDetail.id}`)
      .then(async (res) => {
        console.log(res);
        const resData = res.data.data;
        let isolationPlanData = [];
        const imageLink = api.imageUrl.getUploadFile;
        if (resData.isolationPlan !== null && resData.isolationPlan !== undefined) {
          const getIsolationPlan = String(resData.isolationPlan).split(",");
          isolationPlanData = await axiosPrivate.post(imageLink, getIsolationPlan);
        }
        setDeisolationBol(
          !resData.isAllowedAdopt && resData.isDeIsolation ? true : false,
        );
        setCertificateInfo({
          ...resData,
          isolationPlan:
            resData.isolationPlan !== null && resData.isolationPlan !== undefined
              ? isolationPlanData.data.data
              : [],
        });
        originalCertInfoRef.current = resData;
        setClosedRemark({
          PH: resData.phCertificateClosedReason,
          LPI: resData.lpiCertificateClosedReason,
        });
        setChecked({
          electrical: resData.electricalDetails !== null ? true : false,
          mechanical: resData.mechanicalDetails !== null ? true : null,
        });
        setAutoCompleteValue({
          io:
            resData.isolationOwnerId !== null
              ? resData?.isolationOwnerUserDetail?.firstName +
                " " +
                resData?.isolationOwnerUserDetail?.lastName
              : "",
          iv:
            resData.isolationVerifierId !== null
              ? resData?.isolationVerifierUserDetail?.firstName +
                " " +
                resData?.isolationVerifierUserDetail?.lastName
              : "",
          reconnectionIO:
            resData.reconnectionPermitIssuerId !== null
              ? resData?.reconnectionPermitIssuerUserDetail?.firstName +
                " " +
                resData?.reconnectionPermitIssuerUserDetail?.lastName
              : "",
          reconnectionIV:
            resData.reconnectionPermitVerifierId !== null
              ? resData?.reconnectionPermitVerifierUserDetail?.firstName +
                " " +
                resData?.reconnectionPermitVerifierUserDetail?.lastName
              : "",
        });
        setLPI({
          lpiCom:
            resData.lpiUserDetail !== undefined
              ? resData.lpiUserDetail?.firstName +
                " " +
                resData.lpiUserDetail?.lastName
              : "",
          lpiId: resData.lpiId,
        });
        setApproveInfo({
          engineerName: resData.isEngineerApproved
            ? resData?.engineerUserDetail?.firstName +
              " " +
              resData?.engineerUserDetail?.lastName
            : "",
          lpiName: resData.isLPIApproved
            ? resData?.lpiUserDetail?.firstName +
              " " +
              resData?.lpiUserDetail?.lastName
            : "",
          certificateClosedName: resData.isPHCertificateClosed
            ? approvedData?.permitHolderUser?.firstName +
              " " +
              approvedData?.permitHolderUser?.lastName
            : "",
          lpiCertClosedName: resData.isLPICertificateClosed
            ? resData?.lpiUserDetail?.firstName +
              " " +
              resData?.lpiUserDetail?.lastName
            : "",
        });
        console.log((login.userId === approvedData.permitHolderId &&  roleName === roleNameString.contractStaff) &&
              roleName !== roleNameString.admin,'cehck')
        const newRoleAccess = {
          submitButton:
            roleName === roleNameString.contractStaff &&
            approvedData.assignedUsers.includes(login.userId) &&
            (res.data.data.status === 8 || res.data.data.status === 10)
              ? (roleName === roleNameString.contractStaff &&
                  approvedData.assignedUsers.includes(login.userId) &&
                  (res.data.data.status === null ||
                    res.data.data.status === 8 ||
                    res.data.data.status === 10) &&
                  !approvedData.isCancel === true) ||
                (roleName === roleNameString.pi &&
                  approvedData.isHSSEApproved &&
                  !approvedData.isPermitIssuerApproved &&
                  (res.data.data.status !== 8 || res.data.data.status !== 10) &
                    (!approvedData.isCancel === true)) ||
                (roleName === roleNameString.technican &&
                  approvedData.technicianId === login.userId &&
                  !approvedData.isTechnicianApproved &&
                  (res.data.data.status !== 8 || res.data.data.status !== 10) &
                    (!approvedData.isCancel === true))
              : (roleName === roleNameString.contractStaff &&
                  approvedData.assignedUsers.includes(login.userId) &&
                  (!approvedData.isContractApproved ||
                    res.data.data.status === null) &&
                  (res.data.data.status !== 8 || res.data.data.status !== 10) &&
                  !approvedData.isCancel === true) ||
                (roleName === roleNameString.pi &&
                  approvedData.isHSSEApproved &&
                  !approvedData.isPermitIssuerApproved &&
                  (res.data.data.status !== 8 || res.data.data.status !== 10) &
                    (!approvedData.isCancel === true)) ||
                (roleName === roleNameString.technican &&
                  approvedData.technicianId === login.userId &&
                  // !approvedData.isTechnicianApproved &&
                  res.data.data.status === 1 &&
                  (res.data.data.status !== 8 || res.data.data.status !== 10) &
                    (!approvedData.isCancel === true)),
          piContract:
            roleName === roleNameString.contractStaff &&
            approvedData.assignedUsers.includes(login.userId) &&
            (res.data.data.status === 8 || res.data.data.status === 10)
              ? (roleName === roleNameString.contractStaff &&
                  approvedData.assignedUsers.includes(login.userId) &&
                  (res.data.data.status === null ||
                    res.data.data.status === 8 ||
                    res.data.data.status === 10) &&
                  !approvedData.isCancel === true) ||
                (roleName === roleNameString.pi &&
                  approvedData.isHSSEApproved &&
                  !approvedData.isPermitIssuerApproved &&
                  (res.data.data.status !== 8 || res.data.data.status !== 10) &
                    (!approvedData.isCancel === true))
              : (roleName === roleNameString.contractStaff &&
                  approvedData.assignedUsers.includes(login.userId) &&
                  (!approvedData.isContractApproved ||
                    res.data.data.status === null) &&
                  (res.data.data.status !== 8 || res.data.data.status !== 10) &&
                  !approvedData.isCancel === true) ||
                (roleName === roleNameString.pi &&
                  approvedData.isHSSEApproved &&
                  !approvedData.isPermitIssuerApproved &&
                  approvedData.assignedUsers.includes(login.userId) &&
                  (!approvedData.isContractApproved ||
                    res.data.data.status === null) &&
                  (res.data.data.status !== 8 || res.data.data.status !== 10) &&
                  !approvedData.isCancel === true) ||
                (roleName === roleNameString.pi &&
                  approvedData.isHSSEApproved &&
                  !approvedData.isPermitIssuerApproved &&
                  (res.data.data.status !== 8 || res.data.data.status !== 10) &
                    (!approvedData.isCancel === true)),
          adminCancelButton:
            roleName === roleNameString.admin &&
            !res.data.data.isLPIApproved &&
            res.data.data.isCancel === false,
          contractStaff:
            !(
              roleName === roleNameString.contractStaff &&
              approvedData.assignedUsers.includes(login.userId)
            ) ||
            (approvedData.isContractApproved &&
              res.data.data.status !== null &&
              res.data.data.status !== 8 &&
              res.data.data.status !== 10 &&
              res.data.data.status !== 1) ||
            approvedData.isCancel === true,
          // && approvedData.formStatus !== 11 ||  roleName === roleNameString.admin,
          engineer:
            !(
              roleName === roleNameString.engineer &&
              res.data.data.isolationOwnerId !== null &&
              res.data.data.isolationOwnerId !== undefined &&
              res.data.data.isolationVerifierId !== null &&
              res.data.data.isolationVerifierId !== undefined &&
              approvedData.engineerId === login.userId
            ) ||
            res.data.data.isEngineerApproved ||
            res.data.data.status === 8 ||
            res.data.data.status === 10 ||
            res.data.data.isCancel ||
            approvedData.isCancel === true,
          engineerCancel:
            !(
              ((roleName === roleNameString.engineer &&
                approvedData.engineerId === login.userId) ||
                roleName === roleNameString.admin) &&
              res.data.data.isolationOwnerId !== null &&
              res.data.data.isolationOwnerId !== undefined &&
              res.data.data.isolationVerifierId !== null &&
              res.data.data.isolationVerifierId !== undefined
            ) ||
            res.data.data.isEngineerApproved ||
            res.data.data.status === 8 ||
            res.data.data.status === 10 ||
            res.data.data.isCancel ||
            approvedData.isCancel === true ||
            roleName === roleNameString.admin,
          lpiCancel:
            !(
              (roleName === roleNameString.lpi ||
                roleName === roleNameString.admin) &&
              approvedData.isPermitIssuerApproved
            ) ||
            res.data.data.isLPIApproved ||
            res.data.data.status === 8 ||
            res.data.data.status === 10 ||
            res.data.data.isCancel ||
            approvedData.isCancel === true,
          lpi:
            !(
              roleName === roleNameString.lpi &&
              approvedData.isPermitIssuerApproved
            ) ||
            res.data.data.isLPIApproved ||
            res.data.data.status === 8 ||
            res.data.data.status === 10 ||
            res.data.data.isCancel ||
            approvedData.isCancel === true,
          // lpiCertClose:
          //           !loginRoleId.includes(roleInfo.lpi)||
          //           res.data.data.isLPICertificateClosed||
          //             !res.data.data.isPHCertificateClosed ||
          //             res.data.data.status === 8 ||
          //             res.data.data.isCancel ||
          //             approvedData.isCancel===true,

          //             lpiCertCloseReason:res.data.data.isLPICertificateClosed?true:(!loginRoleId.includes(roleInfo.lpi)||
          //             res.data.data.isLPICertificateClosed||
          //               !res.data.data.isPHCertificateClosed ||
          //               res.data.data.status === 8 ||
          //               res.data.data.isCancel ||
          //               approvedData.isCancel===true),
          // certClose:
          //   login.userId !== approvedData.permitHolderId ||
          //   res.data.data.isPHCertificateClosed ||
          //   !res.data.data.isLPIApproved ||
          //   res.data.data.status === 8 ||
          //   approvedData.isCancel===true,
          lpiCertClose:
            !(
              (roleName === roleNameString.lpi &&
                res.data.data.lpiUserDetail?.id === login.userId) ||
              roleName === roleNameString.admin
            ) ||
            res.data.data.isLPICertificateClosed ||
            !res.data.data.isPHCertificateClosed ||
            res.data.data.status === 8 ||
            res.data.data.status === 10 ||
            res.data.data.isCancel ||
            approvedData.isCancel === true,

          lpiCertCloseReason: res.data.data.isLPICertificateClosed
            ? true
            : !(
                roleName === roleNameString.lpi &&
                res.data.data.lpiUserDetail?.id === login.userId
              ) ||
              res.data.data.isLPICertificateClosed ||
              //  (res.data.data.isDeIsolation && !res.data.data?.reconnectionIsIsolationVerifierClosed)||
              !res.data.data.isPHCertificateClosed ||
              res.data.data.status === 8 ||
              res.data.data.status === 10 ||
              res.data.data.isCancel ||
              approvedData.isCancel === true,
          certClose:
            (!(login.userId === approvedData.permitHolderId &&  roleName === roleNameString.contractStaff) &&
              roleName !== roleNameString.admin) ||
            res.data.data.isPHCertificateClosed ||
            !res.data.data.isLPIApproved ||
            res.data.data.status === 8 ||
            res.data.data.status === 10 ||
            approvedData.isCancel === true ||
            (roleName === roleNameString.admin &&
              !approvedData.isLeadPermitIssuerApproved) ||
            approvedData.isLeadPermitIssuerApproved === null,
          io:
            !(
              roleName === roleNameString.isolationOwner &&
              approvedData.isLeadPermitIssuerApproved
            ) ||
            login.userId !== res.data.data.isolationOwnerId ||
            res.data.data.isIsolationOwnerApproved ||
            !approvedData.isContractApproved ||
            res.data.data.status === 8 ||
            res.data.data.status === 10 ||
            approvedData.isCancel === true,
          iv:
            !(
              roleName === roleNameString.isolationVerifier &&
              approvedData.isLeadPermitIssuerApproved
            ) ||
            login.userId !== res.data.data.isolationVerifierId ||
            res.data.data.isIsolationVerifierApproved ||
            !res.data.data.isIsolationOwnerApproved ||
            res.data.data.status === 8 ||
            res.data.data.status === 10 ||
            approvedData.isCancel === true,
          reconnectionIO:
            !(roleName === roleNameString.isolationOwner) ||
            login.userId !== res.data.data.reconnectionPermitIssuerId ||
            res.data.data?.reconnectionIsIsolationOwnerClosed ||
            !res.data.data.isPHCertificateClosed ||
            !(!res.data.data.isAllowedAdopt && res.data.data.isDeIsolation) ||
            res.data.data.status === 8 ||
            res.data.data.status === 10 ||
            approvedData.isCancel === true,
          reconnectionIV:
            !(roleName === roleNameString.isolationVerifier) ||
            login.userId !== res.data.data.reconnectionPermitVerifierId ||
            res.data.data?.reconnectionIsIsolationVerifierClosed ||
            !res.data.data.reconnectionIsIsolationOwnerClosed ||
            res.data.data.status === 8 ||
            res.data.data.status === 10 ||
            approvedData.isCancel === true,
          technician:
            !(
              roleName === roleNameString.technican &&
              approvedData.technicianId === login.userId
            ) ||
            !res.data.data.isPHCertificateClosed ||
            (!res.data.data.isAllowedAdopt && res.data.data.isDeIsolation) ||
            res.data.data.status === 8 ||
            res.data.data.status === 10 ||
            approvedData.isCancel === true,
          assignIOIV:
            !(
              roleName === roleNameString.technican &&
              approvedData.technicianId === login.userId &&
              approvedData.isContractApproved &&
              res.data.data.status !== null
            ) ||
            //approvedData.isTechnicianApproved ||
            res.data.status === 1 ||
            res.data.data.status === 8 ||
            res.data.data.status === 10 ||
            res.data.data.status === 4 ||
            approvedData.isCancel === true,
        };
        const resolvedRoleAccess = approvedData.isPermitClosed
          ? {
              contractStaff: true,
              engineer: true,
              lpi: true,
              lpiCertClose: true,
              lpiCertCloseReason: true,
              certClose: true,
              io: true,
              iv: true,
              reconnectionIV: true,
              reconnectionIO: true,
              technician: true,
              piContract: false,
              assignIOIV: true,
              submitButton: false,
              engineerCancel: true,
              lpiCancel: true,
              adminCancelButton: false,
            }
          : newRoleAccess;
        originalRoleAccessRef.current = resolvedRoleAccess;
        setRoleAccess(resolvedRoleAccess);
        setRemarkButton({
          ...remarkButton,
          remarkOpen:
            (res.data.data.isCancel &&
              res.data.data.cancelRemarks !== null &&
              res.data.data.cancelRemarks !== "") ||
            (!res.data.data.isLPIApproved &&
              res.data.data.rejectedRemarks !== null &&
              res.data.data.rejectedRemarks !== "")
              ? true
              : false,
        });
        getLPI();
        setIsolationData([
          {
            id: 1,
            rowName: "Isolation Owner",
            fieldName: "isolationOwnerId",
            Name:
              res.data.data.isolationOwnerId !== null
                ? res.data.data.isolationOwnerId
                : "",
            action: "",
            autoCom: "io",
          },
          {
            id: 2,
            rowName: "Isolation Verifier",
            fieldName: "isolationVerifierId",
            Name:
              res.data.data.isolationVerifierId !== null
                ? res.data.data.isolationVerifierId
                : "",
            action: "",
            autoCom: "iv",
          },
        ]);
        setReconnectionData([
          {
            id: 1,
            rowName: "Isolation Owner",
            fieldName: "isolationOwnerId",
            Name:
              res.data.data.reconnectionPermitIssuerId !== null
                ? res.data.data.reconnectionPermitIssuerId
                : "",
            action: "",
            autoCom: "reconnectionIO",
          },
          {
            id: 2,
            rowName: "Isolation Verifier",
            fieldName: "isolationVerifierId",
            Name:
              res.data.data.reconnectionPermitVerifierId !== null
                ? res.data.data.reconnectionPermitVerifierId
                : "",
            action: "",
            autoCom: "reconnectionIV",
          },
        ]);
        if (
          certificateDetail.isAdopted === true &&
          res.data.data.adoptionHistory
        ) {
          try {
            const parsed = JSON.parse(res.data.data.adoptionHistory);
            const histList = Array.isArray(parsed) ? parsed : [];
            setAdoptionHistoryList(histList);
            if (histList.length > 0) {
              const currentSeqNo = searchParams.get("no");
              const matchIndex = histList.findIndex(
                (item) => item.fromSeqNo === currentSeqNo,
              );
              if (matchIndex !== -1) {
                setActiveTab(matchIndex + 1);
                applyDataToState(histList[matchIndex].previousState);
                setRoleAccess({
                  contractStaff: true,
                  engineer: true,
                  lpi: true,
                  lpiCertClose: true,
                  lpiCertCloseReason: true,
                  certClose: true,
                  io: true,
                  iv: true,
                  reconnectionIV: true,
                  reconnectionIO: true,
                  technician: true,
                  piContract: false,
                  assignIOIV: true,
                  submitButton: false,
                  engineerCancel: true,
                  lpiCancel: true,
                  adminCancelButton: false,
                });
              }
            }
          } catch (e) {
            console.error("Failed to parse adoptionHistory", e);
            setAdoptionHistoryList([]);
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
    const getIO = api.user.getFilteredUsers;
    const IODataFilter = {
      companyId: companyInfo.ps,
      roleId: roleInfo.isolationOwner,
      terminalId: approvedData.terminalId,
    };
    axiosPrivate
      .post(`${getIO}`, IODataFilter)
      .then((res) => {
        setIOData(res.data.data);
      })
      .catch((e) => {
        setIOData([]);
        console.log(e);
      });
    const IVDataFilter = {
      companyId: companyInfo.ps,
      roleId: roleInfo.isolationVerifier,
      terminalId: approvedData.terminalId,
    };
    axiosPrivate
      .post(`${getIO}`, IVDataFilter)
      .then((res) => {
        setIVData(res.data.data);
      })
      .catch((e) => {
        setIVData([]);
        console.log(e);
      });
    setLoading(false);
  };

  const initialValue = {
    ...certificateInfo,
    id: certificateInfo.id,
    formId: certificateInfo.formId,
    lotoNo: certificateInfo.lotoNo,
    isolatedEquipment: certificateInfo.isolatedEquipment,
    locationText: certificateInfo.locationText,
    specifyEnergyIsolatedId: certificateInfo.specifyEnergyIsolatedId,
    isolationOwnerId: certificateInfo.isolationOwnerId,
    isolationVerifierId: certificateInfo.isolationVerifierId,
    electricalDetails: certificateInfo.electricalDetails,
    mechanicalDetails: certificateInfo.mechanicalDetails,
    engineerId: certificateInfo.engineerId,
    isEngineerApproved: certificateInfo.isEngineerApproved,
    engineerApprovedDate: certificateInfo.engineerApprovedDate,
    isPHCertificateClosed: certificateInfo.isPHCertificateClosed,
    phCertificateClosedAt: certificateInfo.phCertificateClosedAt,
    isLPICertificateClosed: certificateInfo.isLPICertificateClosed,
    lpiCertificateClosedAt: certificateInfo.lpiCertificateClosedAt,
    lpiId: certificateInfo.lpiId,
    isLPIApproved: certificateInfo.isLPIApproved,
    lpiApprovedDate: certificateInfo.lpiApprovedDate,
    certificateValidFrom: certificateInfo.certificateValidFrom,
    certificateValidTo: certificateInfo.certificateValidTo,
    reconnectionPermitIssuerId: certificateInfo.reconnectionPermitIssuerId,
    reconnectionPermitVerifierId: certificateInfo.reconnectionPermitVerifierId,
    isDeIsolation: certificateInfo.isDeIsolation,
    status: certificateInfo.status,
    isolationPlan: Array.isArray(certificateInfo.isolationPlan)
      ? certificateInfo.isolationPlan
      : [],
  };

  const validationSchema = Yup.object().shape({
    lotoNo: Yup.string().required("This field is required"),

    isolatedEquipment: Yup.string().required("This field is required"),

    locationText: Yup.string().required("This field is required"),

    specifyEnergyIsolatedId: Yup.string().required("This field is required"),

    certificateValidTo: Yup.string()
      .required("This field is required")
      .test(
        "valid-date-range-to",
        "The 'Until' date should not be before the 'From' date.",
        function (value) {
          const { certificateValidFrom } = this.parent;
          if (value && certificateValidFrom) {
            return moment(value).isSameOrAfter(moment(certificateValidFrom));
          }
          return true;
        },
      ),

    certificateValidFrom: Yup.string().required("This field is required"),

    
  });

  const onSubmitValidationSchema = Yup.object().shape({
    isolationOwnerId: Yup.string().required("This field is required"),

    isolationVerifierId: Yup.string().required("This field is required"),
    isolationPlan: Yup.string().required("This field is required"),
  });
  const onApproveAndSubmit = (value) => {
    const editLink = api.isolation.edit;
    axiosPrivate
      .put(`${editLink}/${certificateInfo.id}?roleName=${roleName}`, value)
      .then((res) => {
        setConfirm({ ...confirm, submit: false });
        setConfirmValue([]);
        toast.success("Successfully Updated");
        handleCloseClick();
      })
      .catch((e) => {
        toast.error(e.response.data.message);
        setConfirm({ ...confirm, submit: false });
        setConfirmValue([]);
        console.log(e);
      });
  };
  const onReassign = (value, type) => {
    if (!value.lpiId || value.lpiId === certificateInfo.lpiId) {
      toast.error("Please select a different LPI to reassign");
      return;
    }
    const getIsolationPlan = [];
    for (let i = 0; value.isolationPlan.length > i; i++) {
      getIsolationPlan.push(value.isolationPlan[i].id);
    }
    const postData = {
      ...value,
      isolationPlan: getIsolationPlan.toString(),
      isApproved: false,
      isReassignedLPI: type === "lpi",
    };

    const editLink = api.isolation.edit;
    axiosPrivate
      .put(`${editLink}/${certificateInfo.id}?roleName=${roleName}`, postData)
      .then((res) => {
        console.log(res);
        setConfirm({ ...confirm, reAssign: false });
        setConfirmValue([]);
        // setConfirm({ ...confirm, submit: false });
        setConfirmValue([]);
        handleCloseClick();
        toast.success("Successfully Updated");
      })
      .catch((e) => {
        toast.error(e.response.data.message);
        setConfirm({ ...confirm, reAssign: false });
        setConfirmValue([]);

        console.log(e);
      });
  };
  const handleFileUpload = (event, fieldName, setFieldValue, value) => {
    const file = event.target.files[0];
    if (file) {
      const allowedFileTypes = [
        "image/",
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];
      const isFileTypeValid = allowedFileTypes.some((type) =>
        file.type.startsWith(type),
      );
      if (!isFileTypeValid) {
        toast.error(
          "File is not supported. Please upload an image, PDF, or Word document.",
        );
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        const postData = {
          fileName: file.name,
          fileType: file.type,
          base64String: reader.result,
        };
        axiosPrivate
          .post(api.imageUrl.add, postData)
          .then((res) => {
            setFieldValue(fieldName, [...value, res.data.data]);
          })
          .catch((e) => {
            toast.error(e.response.data.message);
          });
      };
      reader.onerror = (error) => console.error("Error reading file:", error);
    }
  };

  const handleDeleteAttach = (values, setFieldValue, fieldName, id) => {
    const deleteFilter = values.filter((d) => d.id === id);
    axiosPrivate
      .post(api.imageUrl.delete, deleteFilter[0])
      .then(() => {
        setFieldValue(fieldName, values.filter((d) => d.id !== id));
        if (fileInputRefIsolationPlan.current) {
          fileInputRefIsolationPlan.current.value = null;
        }
        setConfirm({ ...confirm, deleteAttach: false });
        setConfirmValue([]);
      })
      .catch((e) => {
        toast.error(e.response.data.message);
      });
  };

  const onSubmit = async (value) => {
    let engineerLPIPI =
      (roleName === roleNameString.engineer &&
        approvedData.isContractApproved) ||
      (roleName === roleNameString.lpi && approvedData.isPermitIssuerApproved);

    let statusValidation =
      (roleName === roleNameString.contractStaff &&
        approvedData.assignedUsers.includes(login.userId) &&
        value.status === null) ||
      (roleName === roleNameString.contractStaff &&
        approvedData.assignedUsers.includes(login.userId) &&
        (value.status === 8 || value.status === 10))
        ? 1
        : roleName === roleNameString.engineer &&
            approvedData.engineerId === login.userId &&
            approvedData.isTechnicianApproved &&
            !certificateInfo.isEngineerApproved
          ? 3
          : roleName === roleNameString.lpi &&
              !certificateInfo.isLPIApproved &&
              approvedData.isPermitIssuerApproved &&
              certificateInfo.isEngineerApproved
            ? 4
            : roleName === roleNameString.technican &&
                approvedData.isContractApproved &&
                //!approvedData.isTechnicianApproved &&
                // approvedData.status === 1 &&
                approvedData.technicianId === login.userId
              ? 9
              : value.status;
    const getIsolationPlan = [];
    for (let i = 0; value.isolationPlan.length > i; i++) {
      getIsolationPlan.push(value.isolationPlan[i].id);
    }
    const postData = {
      ...value,
      refNo:
        value.specifyEnergyIsolatedId === operationMeasure.electrical
          ? "ELE001"
          : value.specifyEnergyIsolatedId === operationMeasure.mechanical
            ? "MEC001"
            : value.specifyEnergyIsolatedId === operationMeasure.instrumentation
              ? "INT001"
              : value.refNo,
      isolationOwnerId: isolationData[0].Name,
      isolationVerifierId: isolationData[1].Name,
      reconnectionPermitIssuerId: isolationData[0].Name,
      reconnectionPermitVerifierId: isolationData[1].Name,
      isApproved: engineerLPIPI ? true : null,
      status: statusValidation,
      isolationPlan: getIsolationPlan.toString(),
    };
    console.log(postData);

    if (!roleAccess.assignIOIV) {
      onSubmitValidationSchema
        .validate(postData, { abortEarly: false })
        .then((responseData) => {
          setError({});
          setConfirm({ ...confirm, submit: true });
          setConfirmValue([postData]);

          console.log("no validation errors");
          console.log(responseData);
        })
        .catch((err) => {
          const errors = err.inner.reduce((acc, error) => {
            return {
              ...acc,
              [error.path]: error.errors[0],
            };
          }, {});
          console.log(errors);
          setError(errors);
          toast.error("Please Fill Required Fields");
        });
    } else {
      setError({});
      setConfirm({ ...confirm, submit: true });
      setConfirmValue([postData]);
    }
  };

  const handleCancel = (value, remark) => {
    const getIsolationPlan = [];
    for (let i = 0; (certificateInfo.isolationPlan || []).length > i; i++) {
      getIsolationPlan.push(certificateInfo.isolationPlan[i].id);
    }
    const postData = {
      // ...value,
      // refNo:
      //   value.specifyEnergyIsolatedId === operationMeasure.electrical
      //     ? "ELE001"
      //     : value.specifyEnergyIsolatedId === operationMeasure.mechanical
      //     ? "MEC001"
      //     : value.specifyEnergyIsolatedId === operationMeasure.instrumentation
      //     ? "INT001"
      //     : value.refNo,
      // isolationOwnerId: isolationData[0].Name,
      // isolationVerifierId: isolationData[1].Name,
      // reconnectionPermitIssuerId: isolationData[0].Name,
      // reconnectionPermitVerifierId: isolationData[1].Name,
      ...certificateDetail,
      isolationPlan: getIsolationPlan.toString(),
      isCancel: true,
      cancelRemarks: remark,
    };
    console.log(postData);
    const editLink = api.isolation.edit;
    axiosPrivate
      .put(`${editLink}/${certificateInfo.id}?roleName=${roleName}`, postData)
      .then((res) => {
        setConfirm({ ...confirm, cancel: false });
        setConfirmValue([]);
        toast.success("Successfully Cancelled");
        handleCloseClick();
      })
      .catch((e) => {
        toast.error(e.response.data.message);
        setConfirm({ ...confirm, cancel: false });
        setConfirmValue([]);
        console.log(e);
      });
  };

  const handleIsolation = async () => {
    let ioiv =
      login.userId === certificateInfo.isolationOwnerId ||
      login.userId === certificateInfo.isolationVerifierId ||
      (certificateInfo.isPHCertificateClosed &&
        (login.userId === certificateInfo.reconnectionPermitIssuerId ||
          login.userId === certificateInfo.reconnectionPermitVerifierId));
    let statusValidation =
      login.userId === certificateInfo.isolationOwnerId &&
      !certificateInfo.isIsolationOwnerApproved
        ? 6
        : login.userId === certificateInfo.isolationVerifierId &&
            !certificateInfo.isIsolationVerifierApproved
          ? 7
          : // : loginRoleId.includes(roleInfo.engineer)
            // ? 3
            // : loginRoleId.includes(roleInfo.lpi)
            // ? 4
            certificateInfo.status;
    const getIsolationPlan = [];
    for (let i = 0; certificateInfo.isolationPlan.length > i; i++) {
      getIsolationPlan.push(certificateInfo.isolationPlan[i].id);
    }
    const postData = {
      ...certificateInfo,
      isolationPlan:getIsolationPlan.toString(),
      isApproved: ioiv ? true : null,
      status: statusValidation,

    };
    console.log(postData);
    const editLink = api.isolation.edit;
    await axiosPrivate
      .put(`${editLink}/${certificateInfo.id}?roleName=${roleName}`, postData)
      .then((res) => {
        toast.success("Successfully Updated");
        setConfirm({ ...confirm, ioivApprove: false });
        setConfirmValue([]);
        handleCloseClick();
      })
      .catch((e) => {
        toast.error(e.response.data.message);
        setConfirm({ ...confirm, ioivApprove: false });
        setConfirmValue([]);
        console.log(e);
      });
  };
  const handleIsolationReassign = async (rowData) => {
    console.log("rowdata", rowData);
    const getIsolationPlan = [];
    for (let i = 0; certificateInfo.isolationPlan.length > i; i++) {
      getIsolationPlan.push(certificateInfo.isolationPlan[i].id);
    }
    const postData = {
      ...certificateInfo,
      isolationPlan: getIsolationPlan.toString(),
      isApproved: false,
      isReassignedOwner:
        rowData.autoCom === "io" && rowData?.Name ? true : false,
      isReassignedVerifier:
        rowData.autoCom === "iv" && rowData?.Name ? true : false,
      isolationOwnerId:
        rowData.autoCom === "io" && rowData?.Name
          ? rowData?.Name
          : certificateInfo.isolationOwnerId,
      isolationVerifierId:
        rowData.autoCom === "iv" && rowData?.Name
          ? rowData?.Name
          : certificateInfo.isolationVerifierId,
    };
    console.log("PostData", postData);
    const editLink = api.isolation.edit;
    await axiosPrivate
      .put(`${editLink}/${certificateInfo.id}?roleName=${roleName}`, postData)
      .then((res) => {
        toast.success("Successfully Updated");
        setConfirm({ ...confirm, ioivReassign: false });
        setConfirmValue([]);
        handleCloseClick();
      })
      .catch((e) => {
        toast.error(e.response.data.message);
        setConfirm({ ...confirm, ioivReassign: false });
        setConfirmValue([]);
        console.log(e);
      });
  };
  const handleIsolationReassignInReconnection = async (rowData) => {
    console.log("reco", rowData);
    const getIsolationPlan = [];
    for (let i = 0; certificateInfo.isolationPlan.length > i; i++) {
      getIsolationPlan.push(certificateInfo.isolationPlan[i].id);
    }
    const postData = {
      ...certificateInfo,
      isolationPlan: getIsolationPlan.toString(),
      //isApproved: false,
      isCertificateClosed: true,
      isReassignedReconnectionOwner:
        rowData.autoCom === "reconnectionIO" && rowData?.Name ? true : false,
      isReassignedReconnectionVerifier:
        rowData.autoCom === "reconnectionIV" && rowData?.Name ? true : false,
      reconnectionPermitIssuerId:
        rowData.autoCom === "reconnectionIO" && rowData?.Name
          ? rowData?.Name
          : certificateInfo.reconnectionPermitIssuerId,
      reconnectionPermitVerifierId:
        rowData.autoCom === "reconnectionIV" && rowData?.Name
          ? rowData?.Name
          : certificateInfo.reconnectionPermitVerifierId,
    };
    console.log("PostData", postData);
    const editLink = api.isolation.edit;
    await axiosPrivate
      .put(`${editLink}/${certificateInfo.id}?roleName=${roleName}`, postData)
      .then((res) => {
        toast.success("Successfully Updated");
        setConfirm({ ...confirm, ioivReassign: false });
        setConfirmValue([]);
        handleCloseClick();
      })
      .catch((e) => {
        toast.error(e.response.data.message);
        setConfirm({ ...confirm, ioivReassign: false });
        setConfirmValue([]);
        console.log(e);
      });
  };
  const handleReconnection = () => {
    const closeCertLink = api.isolation.closeCertificate;
    const postData = {
      id: certificateInfo.id,
      isCertificateClosed: true,
    };
    console.log(postData);
    axiosPrivate
      .put(
        `${closeCertLink}/${certificateInfo.id}?roleName=${roleName}`,
        postData,
      )
      .then((res) => {
        toast.success("Certificate Closed");
        setConfirm({ ...confirm, deIsolationTrue: false });
        setConfirmValue([]);
        handleCloseClick();
      })
      .catch((e) => {
        toast.error(e.response.data.message);
        setConfirm({ ...confirm, deIsolationTrue: false });
        setConfirmValue([]);
        console.log(e);
      });
  };

  const handleCloseCertificate = () => {
    // const validatePermit=api.PTWForm.validatePermitShift
    //   if(certificateDetail.isPHCertificateClosed){
    const closeCertLink = api.isolation.closeCertificate;
    const postData = {
      id: certificateInfo.id,
      isCertificateClosed: true,
      isDeIsolation: true,
      isAllowedAdopt: !deisolationBol,
      certificateClosedReason: certificateDetail.isPHCertificateClosed
        ? closedRemark.LPI
        : closedRemark.PH,
    };
    console.log(postData);

    axiosPrivate
      .put(
        `${closeCertLink}/${certificateInfo.id}?roleName=${roleName}`,
        postData,
      )
      .then((res) => {
        toast.success("Certificate Closed");
        setConfirm({ ...confirm, close: false });
        setConfirmValue([]);
        handleCloseClick();
      })
      .catch((e) => {
        toast.error(e.response.data.message);
        setConfirm({ ...confirm, close: false });
        setConfirmValue([]);
        console.log(e);
      });
    // }else{
    //   axiosPrivate.get(`${validatePermit}/${approvedData.id}`).then(res=>{
    //     const closeCertLink = api.isolation.closeCertificate;
    //     const postData = {
    //       id: certificateInfo.id,
    //       isCertificateClosed: true,
    //       isDeIsolation:deisolationBol,
    //       certificateClosedReason: closedRemark.PH,
    //     };
    //     console.log(postData)
    //      axiosPrivate
    //       .put(`${closeCertLink}/${certificateInfo.id}`, postData)
    //       .then((res) => {
    //         toast.success("Certificate Closed");
    //         handleCloseClick();
    //       })
    //       .catch((e) => {
    //         toast.error(e.response.data.message)
    //         console.log(e);
    //       });
    //       }).catch(e=>{
    //             console.log(e)
    //             toast.error("Permit Is Not Active")
    //           })
    // }
  };

  const handleReject = (value, remark) => {
    const getIsolationPlan = [];
    for (let i = 0; value.isolationPlan.length > i; i++) {
      getIsolationPlan.push(value.isolationPlan[i].id);
    }
    const postData = {
      ...value,
      isolationPlan: getIsolationPlan.toString(),
      isolationOwnerId: isolationData[0].Name,
      isolationVerifierId: isolationData[1].Name,
      reconnectionPermitIssuerId: isolationData[0].Name,
      reconnectionPermitVerifierId: isolationData[1].Name,
      isApproved: false,
      remarks: remark,
      status: roleName === roleNameString.engineer ? 10 : 8,
    };
    console.log(postData);
    const editLink = api.isolation.edit;
    axiosPrivate
      .put(`${editLink}/${certificateInfo.id}?roleName=${roleName}`, postData)
      .then((res) => {
        console.log(res);

        // getData()
        handleCloseClick();
        setRemarkButton({ ...remarkButton, reject: false });
        toast.success("Successfully Rejected");
      })
      .catch((e) => {
        toast.error(e.response.data.message);
        console.log(e);
      });
  };
  // const boundHandleClear = (cell) => {
  //   cell.row.original.Name = null;
  //   setAutoCompleteValue({
  //     ...autoCompleteValue,
  //     [cell.row.original.autoCom]: "",
  //   });
  //   const dataUpdate = [...isolationData];
  //   dataUpdate[cell.row.original.id - 1].Name = null;
  //   setIsolationData(dataUpdate);
  // };
  const isolationColumns = [
    {
      accessor: "rowName",
      Cell: ({ cell }) => {
        return (
          <Typography sx={{ fontSize: "15px", fontWeight: 700 }}>
            {cell.value}
          </Typography>
        );
      },
    },
    //     {
    //       Header: "Name",
    //       accessor: "name",
    //       Cell: ({ cell }) => {
    //         return (
    //           <>
    //             {/* <Autocomplete
    //               readOnly={roleAccess.assignIOIV}
    //               name="name"
    //               inputValue={autoCompleteValue[cell.row.original.autoCom]}
    //               filterOptions={filterOptions}
    //               loading={
    //                 cell.row.original.autoCom === "io"
    //                   ? ioData.length === 0
    //                   : ivData.length === 0
    //               }
    //               options={cell.row.original.autoCom === "io" ? ioData : ivData}
    //               PaperComponent={CustomPaper}
    //               getOptionLabel={(option) =>
    //                 option.firstName + " " + option.lastName || option
    //               }
    //               onChange={(event, value) => {
    //                 if (value) {
    //                   cell.row.original.Name = value.id;
    //                   setAutoCompleteValue({
    //                     ...autoCompleteValue,
    //                     [cell.row.original.autoCom]:
    //                       value.firstName + " " + value.lastName,
    //                   });
    //                 } else {
    //                   cell.row.original.Name = null;
    //                   setAutoCompleteValue({
    //                     ...autoCompleteValue,
    //                     [cell.row.original.autoCom]: "",
    //                   });
    //                 }
    //               }}
    //               onBlur={(e, value) => {
    //                 if (value) {
    //                   const dataUpdate = isolationData;
    //                   dataUpdate[cell.row.original.id - 1].Name = value.id;
    //                   setIsolationData(dataUpdate);
    //                 }
    //               }}
    //               renderInput={(params) => (
    //                 <TextField
    //                   {...params}
    //                   name="companyId"
    //                   size="small"
    //                   // variant="standard"
    //                   fullWidth
    //                   onChange={(e) => {
    //                     setAutoCompleteValue({
    //                       ...autoCompleteValue,
    //                       [cell.row.original.autoCom]: e.target.value,
    //                     });
    //                   }}
    //                   sx={{
    //                     "& .MuiOutlinedInput-root": {
    //                       backgroundColor: roleAccess.assignIOIV
    //                         ? commonCss.readOnlyBGColor
    //                         : commonCss.inputBackgroundColor,
    //                       borderRadius: commonCss.inputBorderRadius,
    //                     },
    //                     "& .MuiOutlinedInput-notchedOutline": {
    //                       borderColor: commonCss.inputBorderColor,
    //                     },
    //                   }}
    //                 />
    //               )}
    //             /> */}
    //             {/* <Box sx={{ position: 'relative', width: '100%' }}> */}
    //   <Autocomplete
    //     readOnly={roleAccess.assignIOIV}
    //     name="name"
    //     value={cell.row.original.Name ?
    //       (cell.row.original.autoCom === "io" ? ioData : ivData).find(item => item.id === cell.row.original.Name) :
    //       null
    //     }
    //     inputValue={autoCompleteValue[cell.row.original.autoCom]}
    //     filterOptions={filterOptions}
    //     loading={
    //       cell.row.original.autoCom === "io"
    //         ? ioData.length === 0
    //         : ivData.length === 0
    //     }
    //     options={cell.row.original.autoCom === "io" ? ioData : ivData}
    //     PaperComponent={CustomPaper}
    //     getOptionLabel={(option) =>
    //       option.firstName + " " + option.lastName || option
    //     }
    //     onChange={(event, value) => {
    //       if (value) {
    //         cell.row.original.Name = value.id;
    //         setAutoCompleteValue({
    //           ...autoCompleteValue,
    //           [cell.row.original.autoCom]: value.firstName + " " + value.lastName,
    //         });
    //       } else {
    //         boundHandleClear(cell);
    //       }
    //     }}
    //     onBlur={(e, value) => {
    //       if (value) {
    //         const dataUpdate = isolationData;
    //         dataUpdate[cell.row.original.id - 1].Name = value.id;
    //         setIsolationData(dataUpdate);
    //       }
    //     }}
    //     renderInput={(params) => (
    //       <TextField
    //         {...params}
    //         name="companyId"
    //         size="small"
    //         fullWidth
    //         onChange={(e) => {
    //           setAutoCompleteValue({
    //             ...autoCompleteValue,
    //             [cell.row.original.autoCom]: e.target.value,
    //           });
    //         }}
    //         sx={{
    //           "& .MuiOutlinedInput-root": {
    //             backgroundColor: roleAccess.assignIOIV
    //               ? commonCss.readOnlyBGColor
    //               : commonCss.inputBackgroundColor,
    //             borderRadius: commonCss.inputBorderRadius,
    //             paddingRight: '32px', // Make space for clear button
    //           },
    //           "& .MuiOutlinedInput-notchedOutline": {
    //             borderColor: commonCss.inputBorderColor,
    //           },
    //         }}
    //       />
    //     )}
    //   />

    //   {autoCompleteValue[cell.row.original.autoCom] && !roleAccess.assignIOIV && (
    //     <IconButton
    //       size="small"
    //      onClick={boundHandleClear}
    //       sx={{
    //         position: 'absolute',
    //         right: '28px',
    //         top: '50%',
    //         transform: 'translateY(-50%)',
    //         zIndex: 1,
    //       }}
    //     >
    //       <Clear fontSize="small" />
    //     </IconButton>
    //   )}

    // {error[cell.row.original.fieldName] !== undefined && (
    //   <ErrorProps>{error[cell.row.original.fieldName]}</ErrorProps>
    // )}
    //             {error[cell.row.original.fieldName] !== undefined && (
    //               <ErrorProps>{error[cell.row.original.fieldName]}</ErrorProps>
    //             )}
    //           </>
    //         );
    //       },
    //     },
    {
      Header: "Name",
      accessor: "name",
      Cell: ({ cell }) => {
        return (
          <Box sx={{ position: "relative", width: "100%" }}>
            <Autocomplete
              readOnly={
                roleAccess.assignIOIV && editableRowId !== cell.row.original.id
              }
              name="name"
              inputValue={autoCompleteValue[cell.row.original.autoCom]}
              value={{
                id: cell.row.original.Name,
                firstName: "",
                lastName: "",
              }}
              filterOptions={filterOptions}
              loading={
                cell.row.original.autoCom === "io"
                  ? ioData.length === 0
                  : ivData.length === 0
              }
              options={cell.row.original.autoCom === "io" ? ioData : ivData}
              PaperComponent={CustomPaper}
              getOptionLabel={(option) =>
                option.firstName + " " + option.lastName || option
              }
              onChange={(event, value) => {
                if (value) {
                  cell.row.original.Name = value.id;
                  setAutoCompleteValue({
                    ...autoCompleteValue,
                    [cell.row.original.autoCom]:
                      value.firstName + " " + value.lastName,
                  });
                } else {
                  cell.row.original.Name = null;
                  setAutoCompleteValue({
                    ...autoCompleteValue,
                    [cell.row.original.autoCom]: "",
                  });
                }
              }}
              onBlur={(e, value) => {
                if (value) {
                  const dataUpdate = isolationData;
                  dataUpdate[cell.row.original.id - 1].Name = value.id;
                  setIsolationData(dataUpdate);
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="companyId"
                  size="small"
                  // variant="standard"
                  fullWidth
                  onChange={(e) => {
                    setAutoCompleteValue({
                      ...autoCompleteValue,
                      [cell.row.original.autoCom]: e.target.value,
                    });
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor:
                        roleAccess.assignIOIV &&
                        editableRowId !== cell.row.original.id
                          ? commonCss.readOnlyBGColor
                          : commonCss.inputBackgroundColor,
                      borderRadius: commonCss.inputBorderRadius,
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: commonCss.inputBorderColor,
                    },
                  }}
                />
              )}
            />

            {error[cell.row.original.fieldName] !== undefined && (
              <ErrorProps>{error[cell.row.original.fieldName]}</ErrorProps>
            )}
          </Box>
        );
      },
    },
    {
      Header: "Action",
      accessor: "button",
      Cell: ({ cell }) => {
        return (
          <Button
            variant="contained"
            disabled={
              roleAccess[cell.row.original.autoCom] ||
              editableRowId === 1 ||
              editableRowId === 2 ||
              certificateInfo.isCancel
            }
            sx={{
              backgroundColor: commonCss.blue,
              borderRadius: commonCss.buttonBorderRadius,
              textTransform: "none",
              padding: "0.6rem 1rem",
              color: commonCss.buttonTextColor,
              width: "5vw",
            }}
            onClick={() => {
              setConfirm({ ...confirm, ioivApprove: true });
            }}
          >
            OK
          </Button>
        );
      },
    },
    {
      Header: "Reassign",
      accessor: "buttons",
      Cell: ({ cell }) => {
        const isEditing = editableRowId === cell.row.original.id;

        return (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            {!isEditing ? (
              <Button
                variant="contained"
                // disabled={
                //         roleName === roleNameString.admin
                //           ? false
                //           : roleAccess[cell.row.original.autoCom] || certificateInfo.isCancel
                //           }
                disabled={
                  activeTab !== 0 ||
                  (roleName !== roleNameString.admin &&
                    (roleAccess[cell.row.original.autoCom] ||
                      certificateInfo.isCancel)) ||
                  !cell.row.original.Name // <-- Disable Reassign if Name is empty
                }
                sx={{
                  backgroundColor: commonCss.blue,
                  borderRadius: commonCss.buttonBorderRadius,
                  textTransform: "none",
                  padding: "0.6rem 1rem",
                  color: commonCss.buttonTextColor,
                  width: "7vw",
                }}
                //onClick={() => setEditableRowId(cell.row.original.id)}
                onClick={() => {
                  setEditableRowId(cell.row.original.id);
                  setBackupValues({
                    ...backupValues,
                    [cell.row.original.id]: {
                      name: cell.row.original.Name,
                      display: autoCompleteValue[cell.row.original.autoCom],
                    },
                  });
                }}
              >
                Reassign
              </Button>
            ) : (
              <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: commonCss.green,
                    borderRadius: commonCss.buttonBorderRadius,
                    textTransform: "none",
                    padding: "0.6rem 1rem",
                    color: commonCss.buttonTextColor,
                    width: "8vw",
                  }}
                  onClick={() => {
                    // ✅ Handle Submit
                    console.log("Submit row", cell.row.original.id);
                    setEditableRowId(null); // lock row back after submit
                    setConfirm({ ...confirm, ioivReassign: true });
                    setConfirmValue([cell.row.original]);
                    //  setConfirmValue([{ rowData: cell.row.original, cell }]);
                  }}
                >
                  Submit
                </Button>

                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: commonCss.red,
                    borderRadius: commonCss.buttonBorderRadius,
                    textTransform: "none",
                    padding: "0.6rem 1rem",
                    color: commonCss.buttonTextColor,
                    width: "8vw",
                  }}
                  // onClick={() => setEditableRowId(null)} // ✅ Cancel reassign
                  onClick={() => {
                    const backup = backupValues[cell.row.original.id];
                    if (backup) {
                      cell.row.original.Name = backup.name;
                      setAutoCompleteValue({
                        ...autoCompleteValue,
                        [cell.row.original.autoCom]: backup.display,
                      });
                    }
                    setEditableRowId(null);
                  }}
                >
                  Cancel
                </Button>
              </Box>
            )}
          </Box>
        );
      },
    },

    //   {
    //     Header: "Company",
    //     accessor: "companhy",
    //     Cell:({cell})=>{
    //       const [value,setValue]=useState(cell.value)
    //       return(
    //         <TextField
    //               fullWidth
    //               variant="outlined"
    //               size="small"
    //               value={value}
    //               sx={{
    //                 "& .MuiOutlinedInput-root": {
    //                   backgroundColor: commonCss.inputBackgroundColor,
    //                   borderRadius: commonCss.inputBorderRadius,
    //                 },
    //                 "& .MuiOutlinedInput-notchedOutline": {
    //                   borderColor: commonCss.inputBorderColor,
    //                 },
    //               }}
    //               onChange={(e) => {
    //                 setValue(e.target.value)
    //                 cell.row.original.company = e.target.value;
    //               }}
    //               onBlur={(e) =>
    //                 handleIsolation(
    //                   e.target.value,
    //                   cell.row.original,
    //                   "company"
    //                 )
    //               }
    //             />
    //       )
    //     }
    //   },
    //   {
    //     Header: "Date/Time",
    //     accessor: "date",
    //     Cell:({cell})=>{
    //       const [value,setValue]=useState(cell.value)
    //       return(
    //         <LocalizationProvider dateAdapter={AdapterDayjs}>
    //   <DemoItem>
    //     <DateTimePicker
    //       ampm={false}
    //       format="DD/MM/YYYY HH:mm"
    //       viewRenderers={{
    //         hours: renderTimeViewClock,
    //         minutes: renderTimeViewClock,
    //         seconds: renderTimeViewClock,
    //       }}
    //       slotProps={{
    //         textField: {
    //           size: "small",
    //           variant: "outlined",
    //         },
    //       }}
    //       value={cell.value!==null ? dayjs(cell.value) : null}
    //       onChange={(newValue) => {
    //         if (newValue !== null) {
    //           if (`${newValue.$d}` !== "Invalid Date") {
    //             const dateFrom = moment(newValue.$d).format(
    //               "YYYY-MM-DD HH:MM "
    //             );

    //             setValue(dateFrom)
    //             cell.row.original.date = dateFrom;
    //       }}

    //     }}
    //     onBlur={(e) =>
    //       handleIsolation(
    //         value,
    //         cell.row.original,
    //         "date"
    //       )
    //     }

    //       sx={{
    //         "& .MuiOutlinedInput-root": {
    //           backgroundColor: commonCss.inputBackgroundColor,
    //           borderRadius: commonCss.inputBorderRadius,
    //         },
    //         "& .MuiOutlinedInput-notchedOutline": {
    //           borderColor: commonCss.inputBorderColor,
    //         },
    //       }}
    //       fullWidth
    //     />
    //   </DemoItem>
    // </LocalizationProvider>
    //       )
    //     }
    //   }
  ];

  const reconnectionColumns = [
    {
      accessor: "rowName",
      Cell: ({ cell }) => {
        return (
          <Typography sx={{ fontSize: "15px", fontWeight: 700 }}>
            {cell.value}
          </Typography>
        );
      },
    },
    {
      Header: "Name",
      accessor: "name",
      Cell: ({ cell }) => {
        return (
          <Autocomplete
            readOnly={
              roleAccess.technician && editableRowIdRe !== cell.row.original.id
            }
            name="name"
            inputValue={autoCompleteValue[cell.row.original.autoCom]}
            value={{ id: cell.row.original.Name, firstName: "", lastName: "" }}
            filterOptions={filterOptions}
            loading={
              cell.row.original.autoCom === "reconnectionIO"
                ? ioData.length === 0
                : ivData.length === 0
            }
            options={
              cell.row.original.autoCom === "reconnectionIO" ? ioData : ivData
            }
            PaperComponent={CustomPaper}
            getOptionLabel={(option) =>
              option.firstName + " " + option.lastName || option
            }
            onChange={(event, value) => {
              if (value) {
                cell.row.original.Name = value.id;
                setAutoCompleteValue({
                  ...autoCompleteValue,
                  [cell.row.original.autoCom]:
                    value.firstName + " " + value.lastName,
                });
              } else {
                cell.row.original.Name = null;
                setAutoCompleteValue({
                  ...autoCompleteValue,
                  [cell.row.original.autoCom]: "",
                });
              }
            }}
            onBlur={(e, value) => {
              if (value) {
                const dataUpdate = isolationData;
                dataUpdate[cell.row.original.id - 1].Name = value.id;
                setReconnectionData(dataUpdate);
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                name="companyId"
                size="small"
                // variant="standard"
                fullWidth
                onChange={(e) => {
                  setAutoCompleteValue({
                    ...autoCompleteValue,
                    [cell.row.original.autoCom]: e.target.value,
                  });
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor:
                      roleAccess.technician &&
                      editableRowIdRe !== cell.row.original.id
                        ? commonCss.readOnlyBGColor
                        : commonCss.inputBackgroundColor,
                    borderRadius: commonCss.inputBorderRadius,
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: commonCss.inputBorderColor,
                  },
                }}
              />
            )}
          />
        );
      },
    },
    {
      Header: "Action",
      accessor: "button",
      Cell: ({ cell }) => {
        return (
          <Button
            variant="contained"
            disabled={
              roleAccess[cell.row.original.autoCom] ||
              editableRowIdRe === 1 ||
              editableRowIdRe === 2 ||
              certificateInfo.isCancel
            }
            sx={{
              backgroundColor: commonCss.blue,
              borderRadius: commonCss.buttonBorderRadius,
              textTransform: "none",
              padding: "0.6rem 1rem",
              color: commonCss.buttonTextColor,
              width: "5vw",
            }}
            onClick={() => {
              // if (certificateInfo.isTechnicianReconnection) {
              //   setConfirm({ ...confirm, deIsolationFalse: true });
              //   setConfirmValue([true]);
              // } else {
                setConfirm({ ...confirm, deIsolationTrue: true });
              // }
            }}
          >
            OK
          </Button>
        );
      },
    },
    {
      Header: "Reassign",
      accessor: "buttons",
      Cell: ({ cell }) => {
        const isEditingRe = editableRowIdRe === cell.row.original.id;

        return (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            {!isEditingRe ? (
              <Button
                variant="contained"
                // disabled={
                //         roleName === roleNameString.admin
                //           ? false
                //           : roleAccess[cell.row.original.autoCom] || certificateInfo.isCancel
                //           }
                disabled={
                  activeTab !== 0 ||
                  (roleName !== roleNameString.admin &&
                    (roleAccess[cell.row.original.autoCom] ||
                      certificateInfo.isCancel)) ||
                  !cell.row.original.Name // <-- Disable Reassign if Name is empty
                }
                sx={{
                  backgroundColor: commonCss.blue,
                  borderRadius: commonCss.buttonBorderRadius,
                  textTransform: "none",
                  padding: "0.6rem 1rem",
                  color: commonCss.buttonTextColor,
                  width: "7vw",
                }}
                //   onClick={() => setEditableRowIdRe(cell.row.original.id)}
                onClick={() => {
                  setEditableRowIdRe(cell.row.original.id);
                  setbackupValuesRec({
                    ...backupValuesRec,
                    [cell.row.original.id]: {
                      name: cell.row.original.Name,
                      display: autoCompleteValue[cell.row.original.autoCom],
                    },
                  });
                }}
              >
                Reassign
              </Button>
            ) : (
              <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: commonCss.green,
                    borderRadius: commonCss.buttonBorderRadius,
                    textTransform: "none",
                    padding: "0.6rem 1rem",
                    color: commonCss.buttonTextColor,
                    width: "8vw",
                  }}
                  onClick={() => {
                    // ✅ Handle Submit
                    console.log("Submit row", cell.row.original.id);
                    setEditableRowIdRe(null); // lock row back after submit
                    setConfirm({ ...confirm, ioivReassignReconnection: true });
                    setConfirmValue([cell.row.original]);
                    //  setConfirmValue([{ rowData: cell.row.original, cell }]);
                  }}
                >
                  Submit
                </Button>

                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: commonCss.red,
                    borderRadius: commonCss.buttonBorderRadius,
                    textTransform: "none",
                    padding: "0.6rem 1rem",
                    color: commonCss.buttonTextColor,
                    width: "8vw",
                  }}
                  //   onClick={() => setEditableRowIdRe(null)} // ✅ Cancel reassign
                  onClick={() => {
                    const backupre = backupValuesRec[cell.row.original.id];
                    if (backupre) {
                      cell.row.original.Name = backupre.name;
                      setAutoCompleteValue({
                        ...autoCompleteValue,
                        [cell.row.original.autoCom]: backupre.display,
                      });
                    }
                    setEditableRowIdRe(null);
                  }}
                >
                  Cancel
                </Button>
              </Box>
            )}
          </Box>
        );
      },
    },
  ];

  const handleDeisolationButton = (cert) => {
    const reconnectionCertLink = api.isolation.deisolation;
    const postData = {
      id: certificateInfo.id,
      isCertificateClosed: cert,
      // certificateClosedReason: closedRemark,
      isDeIsolation: true,
      isTechnicianReconnection: true,
    };
    console.log(postData);
    axiosPrivate
      .put(
        `${reconnectionCertLink}/${certificateInfo.id}?roleName=${roleName}`,
        postData,
      )
      .then((res) => {
        toast.success("Certificate Reconnected");
        setConfirm({ ...confirm, deIsolationFalse: false });
        setConfirmValue([]);
        handleCloseClick();
      })
      .catch((e) => {
        toast.error(e.response.data.message);
        setConfirm({ ...confirm, deIsolationFalse: false });
        setConfirmValue([]);
        console.log(e);
      });
  };

  const getLPI = () => {
    const filterData = {
      companyId: null,
      roleId: roleInfo.lpi,
      terminalId: approvedData.terminalId,
    };
    const getUserByTerminalCompanyAndRole = api.user.getFilteredUsers;
    axiosPrivate
      .post(`${getUserByTerminalCompanyAndRole}`, filterData)
      .then((res) => {
        setLpiData(res.data.data);
        console.log(res.data.data);
      })
      .catch((e) => {
        console.log(e);
        setLpiData([]);
      });
  };

  const applyDataToState = async (data) => {
    console.log(data, "applying data");
    let isolationPlanArr = [];
    if (Array.isArray(data.isolationPlan)) {
      isolationPlanArr = data.isolationPlan;
    } else if (
      data.isolationPlan !== null &&
      data.isolationPlan !== undefined &&
      data.isolationPlan !== ""
    ) {
      try {
        const ids = String(data.isolationPlan).split(",");
        const res = await axiosPrivate.post(api.imageUrl.getUploadFile, ids);
        isolationPlanArr = res.data.data;
      } catch (e) {
        isolationPlanArr = [];
      }
    }
    setCertificateInfo({ ...data, isolationPlan: isolationPlanArr });
    setDeisolationBol(
      !data.isAllowedAdopt && data.isDeIsolation ? true : false,
    );
    setChecked({
      electrical: data.electricalDetails != null,
      mechanical: data.mechanicalDetails != null,
    });
    console.log(data, "data in apply");
    setAutoCompleteValue({
      io:
        data.isolationOwnerId != null
          ? (data?.isolationOwnerUserDetail?.firstName || "") +
            " " +
            (data?.isolationOwnerUserDetail?.lastName || "")
          : "",
      iv:
        data.isolationVerifierId != null
          ? (data?.isolationVerifierUserDetail?.firstName || "") +
            " " +
            (data?.isolationVerifierUserDetail?.lastName || "")
          : "",
      reconnectionIO:
        data.reconnectionPermitIssuerId != null
          ? (data?.reconnectionPermitIssuerUserDetail?.firstName || "") +
            " " +
            (data?.reconnectionPermitIssuerUserDetail?.lastName || "")
          : "",
      reconnectionIV:
        data.reconnectionPermitVerifierId != null
          ? (data?.reconnectionPermitVerifierUserDetail?.firstName || "") +
            " " +
            (data?.reconnectionPermitVerifierUserDetail?.lastName || "")
          : "",
    });
    setLPI({
      lpiCom: data.lpiUserDetail
        ? (data.lpiUserDetail.firstName || "") +
          " " +
          (data.lpiUserDetail.lastName || "")
        : "",
      lpiId: data.lpiId,
    });
    setApproveInfo({
      engineerName: data.isEngineerApproved
        ? (data?.engineerUserDetail?.firstName || "") +
          " " +
          (data?.engineerUserDetail?.lastName || "")
        : "",
      lpiName: data.isLPIApproved
        ? (data?.lpiUserDetail?.firstName || "") +
          " " +
          (data?.lpiUserDetail?.lastName || "")
        : "",
      certificateClosedName: data.isPHCertificateClosed
        ? (approvedData?.permitHolderUser?.firstName || "") +
          " " +
          (approvedData?.permitHolderUser?.lastName || "")
        : "",
      lpiCertClosedName: data.isLPICertificateClosed
        ? (data?.lpiUserDetail?.firstName || "") +
          " " +
          (data?.lpiUserDetail?.lastName || "")
        : "",
    });
    setClosedRemark({
      PH: data.phCertificateClosedReason || "",
      LPI: data.lpiCertificateClosedReason || "",
    });
    setIsolationData([
      {
        id: 1,
        rowName: "Isolation Owner",
        fieldName: "isolationOwnerId",
        Name: data.isolationOwnerId ?? "",
        action: "",
        autoCom: "io",
      },
      {
        id: 2,
        rowName: "Isolation Verifier",
        fieldName: "isolationVerifierId",
        Name: data.isolationVerifierId ?? "",
        action: "",
        autoCom: "iv",
      },
    ]);
    setReconnectionData([
      {
        id: 1,
        rowName: "Isolation Owner",
        fieldName: "isolationOwnerId",
        Name: data.reconnectionPermitIssuerId ?? "",
        action: "",
        autoCom: "reconnectionIO",
      },
      {
        id: 2,
        rowName: "Isolation Verifier",
        fieldName: "isolationVerifierId",
        Name: data.reconnectionPermitVerifierId ?? "",
        action: "",
        autoCom: "reconnectionIV",
      },
    ]);
  };

  const handleSelectChange = (event) => {
    const value = Number(event.target.value);
    console.log(value, "selected value");
    setActiveTab(value);
    if (value === 0) {
      if (originalCertInfoRef.current) {
        applyDataToState(originalCertInfoRef.current);
      }
      if (originalRoleAccessRef.current) {
        setRoleAccess(originalRoleAccessRef.current);
      }
    } else {
      const histItem = adoptionHistoryList[value-1];
      if (histItem) {
        const raw = histItem.previousState;
        applyDataToState(raw);
        setRoleAccess({
          contractStaff: true,
          engineer: true,
          lpi: true,
          lpiCertClose: true,
          lpiCertCloseReason: true,
          certClose: true,
          io: true,
          iv: true,
          reconnectionIV: true,
          reconnectionIO: true,
          technician: true,
          piContract: false,
          assignIOIV: true,
          submitButton: false,
          engineerCancel: true,
          lpiCancel: true,
          adminCancelButton: false,
        });
      }
    }
  };

  return (
    <>
      {!loading ? (
        <Formik
          initialValues={initialValue}
          onSubmit={onSubmit}
          enableReinitialize
          validationSchema={validationSchema}
        >
          {({
            handleChange,
            setFieldValue,
            values,
            resetForm,
            errors,
            touched,
            setFieldTouched,
          }) => (
            <Form>
              <Grid2 container size={12} spacing={"1rem"}>
                <Grid2 container size={12} alignItems={"center"}>
                  <Grid2 container size={4}>
                    <Box
                      sx={{
                        backgroundColor: "white",
                        display: "flex",
                        alignItems: "cente",
                        p: 1,
                        cursor: "pointer",
                      }}
                      onClick={handleCloseClick}
                    >
                      <ArrowBack color="rgb(0, 86, 151)" />
                    </Box>
                  </Grid2>
                  <Grid2 container size={4} justifyContent={"center"}>
                    <Typography variant="h5" fontWeight="bold" color="white">
                      Isolation Certificate-Lock out/Tag out
                    </Typography>
                  </Grid2>
                  <Grid2
                    container
                    size={4}
                    justifyContent={"flex-end"}
                    alignItems={"center"}
                    gap={1}
                  >
                    <Box
                      sx={{
                        backgroundColor: "white",
                        p: 1,
                      }}
                    >
                      <Typography variant="body1" fontWeight="bold">
                        Permit To Work No.{" "}
                        <span style={{ color: "#e53e3e" }}>
                          {searchParams.get("no")}
                        </span>
                      </Typography>
                    </Box>
                    {certificateInfo.isreassigned && (
                      <IconButton
                        size="small"
                        onClick={() => setAuditLogOpen(true)}
                        sx={{
                          color: commonCss.orange,
                          border: `1px solid ${commonCss.orange}`,
                          borderRadius: "4px",
                          backgroundColor: "rgba(255, 152, 0, 0.1)",
                          "&:hover": {
                            backgroundColor: "rgba(255, 152, 0, 0.2)",
                          },
                        }}
                        title="View Audit Log"
                      >
                        <Info />
                      </IconButton>
                    )}
                  </Grid2>
                  <Divider
                    sx={{
                      borderColor: commonCss.white,
                      borderWidth: 1,
                      width: "100%",
                    }}
                  />
                </Grid2>
                <Grid2 container size={12} alignItems={"center"}>
                  <Typography color="white" variant="body2">
                    (To be completed only by authorised persons)
                  </Typography>
                </Grid2>
                {certificateDetail.isAdopted === true && (
                  <Grid2 container size={12} alignItems={"center"}>
                    <InputLabel sx={{ color: "white", mr: 1, mb: 0 }}>
                      <Typography
                        variant="body2"
                        fontWeight="bold"
                        color="white"
                      >
                        Select Certificate
                      </Typography>
                    </InputLabel>
                    <Select
                      size="small"
                      value={activeTab}
                      onChange={handleSelectChange}
                      sx={{
                        backgroundColor: "white",
                        borderRadius: commonCss.inputBorderRadius,
                        minWidth: 280,
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: commonCss.inputBorderColor,
                        },
                      }}
                    >
                      <MenuItem value={0}>Deisolation Certificate</MenuItem>
                      {adoptionHistoryList.map((item, index) => (
                        <MenuItem key={index + 1} value={index + 1}>
                          {item.fromSeqNo +
                            "-" +
                            (item.previousState?.refNo ||
                              item.previousState?.refNo) ||
                            `Adoption ${index + 1}`}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid2>
                )}
                <Grid2
                  container
                  size={12}
                  gap={0}
                  sx={{
                    display:
                      certificateInfo.isCancel ||
                      (!values.isLPIApproved &&
                        certificateInfo.rejectRemarks !== null &&
                        certificateInfo.rejectRemarks !== "")
                        ? "default"
                        : "none",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setRemarkButton({
                        ...remarkButton,
                        remarkOpen: !remarkButton.remarkOpen,
                      });
                    }}
                  >
                    {remarkButton.remarkOpen ? (
                      <KeyboardArrowUp sx={{ color: commonCss.yellow }} />
                    ) : (
                      <KeyboardArrowDown sx={{ color: commonCss.yellow }} />
                    )}

                    <Typography
                      sx={{
                        color: commonCss.yellow,
                        ml: "0.6rem",
                        fontWeight: 600,
                      }}
                    >
                      Remark
                    </Typography>
                  </Box>
                  <Collapse
                    in={remarkButton.remarkOpen}
                    sx={{
                      background: "white",
                      width: "100%",
                      p: remarkButton.remarkOpen ? 1 : 0,
                    }}
                  >
                    <RemarkTableView
                      data={
                        certificateInfo.isCancel
                          ? certificateInfo.cancelOthers
                          : certificateInfo.rejectRemarks
                      }
                    />
                    {/* <Typography>
                                      {certificateInfo.isCancel
                                        ? certificateInfo.cancelOthers
                                        : certificateInfo.rejectRemarks}
                                    </Typography> */}
                  </Collapse>
                </Grid2>
                <Grid2 container size={12}>
                  <Paper
                    elevation={3}
                    sx={{
                      borderRadius: commonCss.paperBorderRadius,
                      p: 1.5,
                      background: "white",
                      width: "100%",
                    }}
                  >
                    <Grid2 container spacing={2} mb={2}>
                      <Grid2 size={{ xs: 12, md: 4 }}>
                        <InputLabel sx={{ pl: commonCss.labelPadding }}>
                          <Typography
                            variant="body2"
                            fontWeight={commonCss.labelFontWeight}
                            color={commonCss.labelInputColor}
                          >
                            Identify number(LOTO number)
                            <Typography
                              component="span"
                              color="error"
                              fontWeight="bold"
                              sx={{ ml: 0.5 }}
                            >
                              *
                            </Typography>
                          </Typography>
                        </InputLabel>
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          name="lotoNo"
                          value={values.lotoNo}
                          onChange={handleChange}
                          slotProps={{
                            input: {
                              readOnly: roleAccess.contractStaff,
                            },
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              backgroundColor: roleAccess.contractStaff
                                ? commonCss.readOnlyBGColor
                                : commonCss.inputBackgroundColor,
                              borderRadius: commonCss.inputBorderRadius,
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: commonCss.inputBorderColor,
                            },
                          }}
                        />
                        {errors.lotoNo && (
                          <ErrorMessage name="lotoNo">
                            {(error) => <ErrorProps>{error}</ErrorProps>}
                          </ErrorMessage>
                        )}
                      </Grid2>
                      <Grid2 size={{ xs: 12, md: 4 }}>
                        <InputLabel sx={{ pl: commonCss.labelPadding }}>
                          <Typography
                            variant="body2"
                            fontWeight={commonCss.labelFontWeight}
                            color={commonCss.labelInputColor}
                          >
                            Isolated Equipment
                            <Typography
                              component="span"
                              color="error"
                              fontWeight="bold"
                              sx={{ ml: 0.5 }}
                            >
                              *
                            </Typography>
                          </Typography>
                        </InputLabel>
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          name="isolatedEquipment"
                          value={values.isolatedEquipment}
                          onChange={handleChange}
                          slotProps={{
                            input: {
                              readOnly: roleAccess.contractStaff,
                            },
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              backgroundColor: roleAccess.contractStaff
                                ? commonCss.readOnlyBGColor
                                : commonCss.inputBackgroundColor,
                              borderRadius: commonCss.inputBorderRadius,
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: commonCss.inputBorderColor,
                            },
                          }}
                        />
                        {errors.isolatedEquipment && (
                          <ErrorMessage name="isolatedEquipment">
                            {(error) => <ErrorProps>{error}</ErrorProps>}
                          </ErrorMessage>
                        )}
                      </Grid2>
                      <Grid2 size={{ xs: 12, md: 4 }}>
                        <InputLabel sx={{ pl: commonCss.labelPadding }}>
                          <Typography
                            variant="body2"
                            fontWeight={commonCss.labelFontWeight}
                            color={commonCss.labelInputColor}
                          >
                            Location
                            <Typography
                              component="span"
                              color="error"
                              fontWeight="bold"
                              sx={{ ml: 0.5 }}
                            >
                              *
                            </Typography>
                          </Typography>
                        </InputLabel>
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          name="locationText"
                          value={values.locationText}
                          onChange={handleChange}
                          slotProps={{
                            input: {
                              readOnly: roleAccess.contractStaff,
                            },
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              backgroundColor: roleAccess.contractStaff
                                ? commonCss.readOnlyBGColor
                                : commonCss.inputBackgroundColor,
                              borderRadius: commonCss.inputBorderRadius,
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: commonCss.inputBorderColor,
                            },
                          }}
                        />
                        {errors.locationText && (
                          <ErrorMessage name="locationText">
                            {(error) => <ErrorProps>{error}</ErrorProps>}
                          </ErrorMessage>
                        )}
                      </Grid2>
                      <Grid2 size={{ xs: 12, md: 4 }}>
                        <InputLabel sx={{ pl: commonCss.labelPadding }}>
                          <Typography
                            variant="body2"
                            fontWeight={commonCss.labelFontWeight}
                            color={commonCss.labelInputColor}
                          >
                            Operational Measure Types
                            <Typography
                              component="span"
                              color="error"
                              fontWeight="bold"
                              sx={{ ml: 0.5 }}
                            >
                              *
                            </Typography>
                          </Typography>
                        </InputLabel>
                        <Select
                          size="small"
                          defaultValue=""
                          displayEmpty
                          value={values.specifyEnergyIsolatedId}
                          name="specifyEnergyIsolatedId"
                          readOnly={roleAccess.contractStaff}
                          sx={{
                            borderRadius: "13px",
                            backgroundColor: roleAccess.contractStaff
                              ? commonCss.readOnlyBGColor
                              : commonCss.inputBackgroundColor,
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "747373",
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: commonCss.inputBorderColor,
                            },
                          }}
                          fullWidth
                          onChange={handleChange}
                        >
                          {typeMeasure.map((measure, i) => (
                            <MenuItem
                              key={i}
                              value={measure.id}
                              disabled={getMeasure.includes(measure.id)}
                            >
                              {measure.name}
                            </MenuItem>
                          ))}
                        </Select>
                        {errors.specifyEnergyIsolatedId && (
                          <ErrorMessage name="specifyEnergyIsolatedId">
                            {(error) => <ErrorProps>{error}</ErrorProps>}
                          </ErrorMessage>
                        )}
                      </Grid2>
                      <Grid2 size={{ xs: 12, md: 4 }}>
                        <InputLabel>
                          <Typography
                            variant="body2"
                            fontWeight={commonCss.labelFontWeight}
                            color={commonCss.labelInputColor}
                          >
                            Validity From
                            <Typography
                              component="span"
                              color="error"
                              fontWeight="bold"
                              sx={{ ml: 0.5 }}
                            >
                              *
                            </Typography>
                          </Typography>
                        </InputLabel>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoItem>
                            <DatePicker
                              ampm={false}
                              format="DD/MM/YYYY"
                              readOnly={
                                !roleAccess.piContract ||
                                certificateInfo.isCancel === true
                              }
                              minDate={
                                approvedData.isLeadPermitIssuerApproved
                                  ? dayjs(approvedData.lpiPermitValidFrom)
                                  : approvedData.isPermitIssuerApproved
                                    ? dayjs(approvedData.piPermitValidFrom)
                                    : approvedData.actualPermitValidFrom !==
                                        null
                                      ? dayjs(
                                          approvedData.actualPermitValidFrom,
                                        )
                                      : dayjs(moment())
                              }
                              maxDate={
                                approvedData.isLeadPermitIssuerApproved
                                  ? dayjs(approvedData.lpiPermitValidUpTo)
                                  : approvedData.isPermitIssuerApproved
                                    ? dayjs(approvedData.piPermitValidUpTo)
                                    : approvedData.actualPermitValidUpTo !==
                                        null
                                      ? dayjs(
                                          approvedData.actualPermitValidUpTo,
                                        )
                                      : undefined
                              }
                              value={
                                values.certificateValidFrom !== null
                                  ? dayjs(values.certificateValidFrom)
                                  : null
                              }
                              slotProps={{
                                textField: {
                                  size: "small",
                                  variant: "outlined",
                                },
                              }}
                              onChange={(newValue) => {
                                console.log(newValue);
                                if (newValue !== null) {
                                  if (`${newValue.$d}` !== "Invalid Date") {
                                    // const dateFrom = moment(newValue.$d).format(
                                    //   "YYYY-MM-DD"
                                    // );

                                    // const hour =
                                    //   new Date().getHours() < 10
                                    //     ? "0" + new Date().getHours()
                                    //     : new Date().getHours();
                                    // const min =
                                    //   new Date().getMinutes() < 10
                                    //     ? "0" + new Date().getMinutes()
                                    //     : new Date().getMinutes();
                                    // const sec =
                                    //   new Date().getSeconds() < 10
                                    //     ? "0" + new Date().getSeconds()
                                    //     : new Date().getSeconds();
                                    // const dateFormat =
                                    //   dateFrom +
                                    //   "T" +
                                    //   hour +
                                    //   ":" +
                                    //   min +
                                    //   ":" +
                                    //   sec +
                                    //   "Z";
                                    const dateFrom =
                                      moment(newValue.$d).format("YYYY-MM-DD") +
                                      "T00:00:00Z";
                                    setFieldValue(
                                      "certificateValidFrom",
                                      dateFrom,
                                    );

                                    // const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                                    // const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                                    // const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                                    // const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                                    // setFieldValue("installationDate", dateFormat);
                                  }
                                }
                              }}
                              //  onChange={(newValue) => {
                              //     if (newValue !== null && `${newValue.$d}` !== "Invalid Date") {
                              //       const dateFrom = moment(newValue.$d);
                              //       setFieldValue("certificateValidFrom", dateFrom);
                              //       setFieldValue(
                              //         "certificateValidTo",
                              //         dateFrom.clone().add(7, "days")
                              //       );
                              //     }
                              //   }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: commonCss.inputBorderRadius,
                                  backgroundColor:
                                    !roleAccess.piContract ||
                                    certificateInfo.isCancel === true
                                      ? commonCss.readOnlyBGColor
                                      : commonCss.inputBackgroundColor,
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: commonCss.inputBorderColor,
                                },
                              }}
                              fullWidth
                            />
                            {errors.certificateValidFrom && (
                              <ErrorMessage name="certificateValidFrom">
                                {(error) => <ErrorProps>{error}</ErrorProps>}
                              </ErrorMessage>
                            )}
                          </DemoItem>
                        </LocalizationProvider>
                      </Grid2>
                      <Grid2 size={{ xs: 12, md: 4 }}>
                        <InputLabel>
                          <Typography
                            variant="body2"
                            fontWeight={commonCss.labelFontWeight}
                            color={commonCss.labelInputColor}
                          >
                            Validity Utill
                            <Typography
                              component="span"
                              color="error"
                              fontWeight="bold"
                              sx={{ ml: 0.5 }}
                            >
                              *
                            </Typography>
                          </Typography>
                        </InputLabel>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoItem>
                            <DatePicker
                              ampm={false}
                              format="DD/MM/YYYY"
                              readOnly={
                                !roleAccess.piContract ||
                                certificateInfo.isCancel === true
                              }
                              minDate={
                                approvedData.isLeadPermitIssuerApproved
                                  ? dayjs(approvedData.lpiPermitValidFrom)
                                  : approvedData.isPermitIssuerApproved
                                    ? dayjs(approvedData.piPermitValidFrom)
                                    : approvedData.actualPermitValidFrom !==
                                        null
                                      ? dayjs(
                                          approvedData.actualPermitValidFrom,
                                        )
                                      : values.certificateValidFrom !== null
                                        ? dayjs(values.certificateValidFrom)
                                        : dayjs(moment())
                              }
                              maxDate={
                                approvedData.isLeadPermitIssuerApproved
                                  ? dayjs(approvedData.lpiPermitValidUpTo)
                                  : approvedData.isPermitIssuerApproved
                                    ? dayjs(approvedData.piPermitValidUpTo)
                                    : approvedData.actualPermitValidUpTo !==
                                        null
                                      ? dayjs(
                                          approvedData.actualPermitValidUpTo,
                                        )
                                      : values.certificateValidFrom !== null
                                        ? dayjs(
                                            moment
                                              .utc(values.certificateValidFrom)
                                              .add(7, "days"),
                                          )
                                        : undefined
                              }
                              value={
                                values.certificateValidTo !== null
                                  ? dayjs(values.certificateValidTo)
                                  : null
                              }
                              slotProps={{
                                textField: {
                                  size: "small",
                                  variant: "outlined",
                                },
                              }}
                              // onClose={() => setFieldTouched("certificateValidTo", true, false)}
                              onChange={(newValue) => {
                                console.log(newValue);
                                if (newValue !== null) {
                                  if (`${newValue.$d}` !== "Invalid Date") {
                                    // const dateFrom = moment(newValue.$d).format(
                                    //   "YYYY-MM-DD"
                                    // );

                                    // const hour =
                                    //   new Date().getHours() < 10
                                    //     ? "0" + new Date().getHours()
                                    //     : new Date().getHours();
                                    // const min =
                                    //   new Date().getMinutes() < 10
                                    //     ? "0" + new Date().getMinutes()
                                    //     : new Date().getMinutes();
                                    // const sec =
                                    //   new Date().getSeconds() < 10
                                    //     ? "0" + new Date().getSeconds()
                                    //     : new Date().getSeconds();
                                    // const dateFormat =
                                    //   dateFrom +
                                    //   "T" +
                                    //   hour +
                                    //   ":" +
                                    //   min +
                                    //   ":" +
                                    //   sec +
                                    //   "Z";
                                    const dateFrom =
                                      moment(newValue.$d).format("YYYY-MM-DD") +
                                      "T00:00:00Z";
                                    setFieldValue(
                                      "certificateValidTo",
                                      dateFrom,
                                    );
                                    // setFieldTouched("certificateValidTo", true, false);
                                    // const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                                    // const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                                    // const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                                    // const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                                    // setFieldValue("installationDate", dateFormat);
                                  }
                                }
                              }}
                              // shouldDisableDate={(date) => {
                              //       const validityFrom = values.certificateValidFrom
                              //         ? moment(values.certificateValidFrom)
                              //         : null;
                              //       return (
                              //         !validityFrom ||
                              //         date.isBefore(validityFrom, "day") ||
                              //         date.isAfter(validityFrom.clone().add(7, "days"), "day")
                              //       );
                              //     }}
                              //     onChange={(newValue) => {
                              //       if (newValue !== null && `${newValue.$d}` !== "Invalid Date") {
                              //         const dateTo = moment(newValue.$d);
                              //         setFieldValue("certificateValidTo", dateTo);
                              //       }
                              //     }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: commonCss.inputBorderRadius,
                                  backgroundColor:
                                    !roleAccess.piContract ||
                                    certificateInfo.isCancel === true
                                      ? commonCss.readOnlyBGColor
                                      : commonCss.inputBackgroundColor,
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: commonCss.inputBorderColor,
                                },
                              }}
                              fullWidth
                            />
                            {errors.certificateValidTo && (
                              <ErrorMessage name="certificateValidTo">
                                {(error) => <ErrorProps>{error}</ErrorProps>}
                              </ErrorMessage>
                            )}
                          </DemoItem>
                        </LocalizationProvider>
                      </Grid2>
                    </Grid2>
                  </Paper>
                </Grid2>
                <Grid2 container size={12}>
                  <Paper
                    elevation={3}
                    sx={{
                      borderRadius: commonCss.paperBorderRadius,
                      p: 1.5,
                      background: "white",
                      width: "100%",
                    }}
                  >
                    <Grid2 container spacing={2}>
                      <Grid2 size={12}>
                        <Typography
                          variant="body2"
                          color={commonCss.blue}
                          fontWeight={commonCss.mainLabelHeading}
                        >
                          {certificateDetail.isAdopted === true &&
                          activeTab === 0
                            ? "PERSON(S) COMPLETING THE DEISOLATION"
                            : "PERSON(S) COMPLETING THE ISOLATION"}
                        </Typography>
                      </Grid2>
                      <Grid2 size={12}>
                        <NormalTableWithRadius
                          data={isolationData}
                          columns={isolationColumns}
                        />
                      </Grid2>
                    </Grid2>
                  </Paper>
                </Grid2>
                <Grid2 container size={12}>
                  <Paper
                    elevation={3}
                    sx={{
                      borderRadius: commonCss.paperBorderRadius,
                      p: 1.5,
                      background: "white",
                      width: "100%",
                    }}
                  >
                    <Grid2 container spacing={2} mb={2}>
                      <Typography
                        variant="body2"
                        fontWeight={commonCss.labelFontWeight}
                        color={commonCss.labelInputColor}
                      >
                        I have personally checked the equipment to be worked on
                        under this Isolation certificate and certify it to have
                        been isolated. Accidental reconnection of this equipment
                        has been prevented by the following means:
                      </Typography>
                    </Grid2>

                    <Grid2 container mb={2}>
                      <Grid2 container size={{ xs: 12, md: 4 }} spacing={2}>
                        <FormControlLabel
                          control={
                            <Radio
                              disabled={roleAccess.contractStaff}
                              checked={checked.electrical}
                              onChange={(e) => {
                                setChecked({
                                  electrical: true,
                                  mechanical: false,
                                });
                              }}
                              sx={{
                                color: "rgb(0, 86, 151)",
                                "&.Mui-checked": {
                                  color: "rgb(0, 86, 151)",
                                },
                              }}
                            />
                          }
                          label="Electrical"
                        />
                        <FormControlLabel
                          control={
                            <Radio
                              //  readOnly={roleAccess.contractStaff}
                              disabled={roleAccess.contractStaff}
                              checked={checked.mechanical}
                              onChange={(e) => {
                                setChecked({
                                  electrical: false,
                                  mechanical: true,
                                });
                              }}
                              sx={{
                                color: "rgb(0, 86, 151)",
                                "&.Mui-checked": {
                                  color: "rgb(0, 86, 151)",
                                },
                              }}
                            />
                          }
                          label="Mechanical"
                        />
                      </Grid2>

                      {checked.electrical && (
                        <Grid2 size={{ xs: 12, md: 8 }}>
                          {/* <InputLabel>
                  <Typography variant="body2" fontWeight="bold" color="black">
                    Electrical
                  </Typography>
                </InputLabel> */}
                          <TextField
                            variant="outlined"
                            size="small"
                            name="electricalDetails"
                            value={values.electricalDetails}
                            onChange={handleChange}
                            multiline
                            minRows={2}
                            maxRows={5}
                            fullWidth
                            slotProps={{
                              input: {
                                readOnly: roleAccess.contractStaff,
                              },
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                backgroundColor: roleAccess.contractStaff
                                  ? commonCss.readOnlyBGColor
                                  : commonCss.inputBackgroundColor,
                                borderRadius: commonCss.inputBorderRadius,
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: commonCss.inputBorderColor,
                              },
                            }}
                          />
                        </Grid2>
                      )}

                      {checked.mechanical && (
                        <Grid2 size={{ xs: 12, md: 8 }}>
                          {/* <InputLabel>
                  <Typography variant="body2" fontWeight="bold" color="black">
                    Mechanical
                  </Typography>
                </InputLabel> */}
                          <TextField
                            variant="outlined"
                            size="small"
                            name="mechanicalDetails"
                            value={values.mechanicalDetails}
                            onChange={handleChange}
                            multiline
                            minRows={2}
                            maxRows={5}
                            fullWidth
                            slotProps={{
                              input: {
                                readOnly: roleAccess.contractStaff,
                              },
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                backgroundColor: roleAccess.contractStaff
                                  ? commonCss.readOnlyBGColor
                                  : commonCss.inputBackgroundColor,
                                borderRadius: commonCss.inputBorderRadius,
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: commonCss.inputBorderColor,
                              },
                            }}
                          />
                        </Grid2>
                      )}
                    </Grid2>
                  </Paper>
                </Grid2>

                {/* ── Isolation Plan ── */}
                <Grid2 container size={12}>
                  <Paper
                    elevation={3}
                    sx={{
                      borderRadius: commonCss.paperBorderRadius,
                      p: 1.5,
                      background: "white",
                      width: "100%",
                    }}
                  >
                    <Grid2 container size={12} spacing={"1rem"}>
                      <Grid2 size={12}>
                        <Typography
                          variant="body2"
                          fontWeight={commonCss.mainLabelHeading}
                          color={commonCss.blue}
                        >
                          ISOLATION PLAN
                          <Typography
                              component="span"
                              color="error"
                              fontWeight="bold"
                              sx={{ ml: 0.5 }}
                            >
                              *
                            </Typography>
                        </Typography>
                         
                        
                      </Grid2>
                      <Grid2 size={12}>
                        <Button
                          disabled={roleAccess.assignIOIV}
                          component="label"
                          sx={{
                            background: roleAccess.assignIOIV
                              ? commonCss.readOnlyBGColor
                              : commonCss.inputBackgroundColor,
                            display: "flex",
                            gap: "0.3rem",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            height: "10vh",
                            cursor: roleAccess.assignIOIV ? "not-allowed" : "pointer",
                            border: `1px solid ${commonCss.inputBorderColor}`,
                            borderRadius: commonCss.inputBorderRadius,
                            color: "inherit",
                          }}
                        >
                          <FileUploadOutlined />
                          <Typography sx={{ fontSize: "0.9rem", textTransform: "none" }}>
                            Upload Isolation Plan
                          </Typography>
                          <input
                            type="file"
                            ref={fileInputRefIsolationPlan}
                            hidden
                            onChange={(e) =>
                              handleFileUpload(
                                e,
                                "isolationPlan",
                                setFieldValue,
                                values.isolationPlan,
                              )
                            }
                          />
                        </Button>
                        <Box
                          sx={{
                            backgroundColor: "white",
                            p: 1,
                            display:
                              Array.isArray(values.isolationPlan) &&
                              values.isolationPlan.length !== 0
                                ? "default"
                                : "none",
                          }}
                        >
                          {(Array.isArray(values.isolationPlan)
                            ? values.isolationPlan
                            : []
                          ).map((att, i) => (
                            <Box key={i}>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  width: "100%",
                                }}
                              >
                                <Typography sx={{ width: "70%" }}>
                                  {att.fileName}
                                </Typography>
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    width: "30%",
                                    alignItems: "center",
                                  }}
                                >
                                  <IconButton
                                    onClick={() => window.open(att.fileUrl, "_blank")}
                                  >
                                    <Visibility sx={{ color: commonCss.blue }} />
                                  </IconButton>
                                  <IconButton
                                    disabled={roleAccess.assignIOIV}
                                    onClick={() => {
                                      setConfirm({ ...confirm, deleteAttach: true });
                                      setConfirmValue([
                                        values.isolationPlan,
                                        setFieldValue,
                                        "isolationPlan",
                                        att.id,
                                      ]);
                                    }}
                                  >
                                    <DeleteOutlined sx={{ color: commonCss.red }} />
                                  </IconButton>
                                </Box>
                              </Box>
                              <Divider />
                            </Box>
                          ))}
                        </Box>
                        {error["isolationPlan"] !== undefined && (
              <ErrorProps>{error["isolationPlan"]}</ErrorProps>
            )}
                      </Grid2>
                    </Grid2>
                  </Paper>
                </Grid2>

                <Grid2 container size={{ xs: 12, md: 4 }}>
                  <Paper
                    elevation={3}
                    sx={{
                      borderRadius: commonCss.paperBorderRadius,
                      p: 1.5,
                      background: "white",
                      width: "100%",
                    }}
                  >
                    <Grid2 container size={12} spacing={"1rem"}>
                      <Grid2 size={12}>
                        <Typography
                          variant="body2"
                          fontWeight={commonCss.mainLabelHeading}
                          color={commonCss.blue}
                          textAlign={"center"}
                        >
                          Engineer
                        </Typography>
                        <Divider
                          sx={{
                            borderColor: commonCss.darkBlue,
                            borderWidth: 1,
                            width: "100%",
                            mt: 1,
                          }}
                        />
                      </Grid2>
                      <Grid2 size={12}>
                        <Typography
                          variant="body2"
                          fontWeight={commonCss.normalSentenceWeight}
                          color={commonCss.normalSenternceColor}
                          sx={{ textTransform: "none" }}
                        >
                          I certify that I have reviewed the proposed work and I
                          am satisfied that it is adequately described on the
                          permit to work and that the precautions detailed are
                          adequate and clearly defined
                        </Typography>
                      </Grid2>
                      <Grid2 size={{ xs: 12 }}>
                        <InputLabel>
                          <Typography
                            variant="body2"
                            fontWeight={commonCss.labelFontWeight}
                            color={commonCss.labelInputColor}
                          >
                            Name
                          </Typography>
                        </InputLabel>
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          value={approveInfo.engineerName}
                          slotProps={{
                            input: {
                              readOnly: true, // Set readOnly to true
                            },
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              backgroundColor: commonCss.readOnlyBGColor,
                              borderRadius: commonCss.inputBorderRadius,
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: commonCss.inputBorderColor,
                            },
                          }}
                        />
                      </Grid2>
                      <Grid2 size={{ xs: 12 }}>
                        <InputLabel>
                          <Typography
                            variant="body2"
                            fontWeight={commonCss.labelFontWeight}
                            color={commonCss.labelInputColor}
                          >
                            Date/Time
                          </Typography>
                        </InputLabel>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoItem>
                            <DateTimePicker
                              ampm={false}
                              format="DD/MM/YYYY HH:mm"
                              value={
                                values.isEngineerApproved
                                  ? dayjs(values.engineerApprovedDate)
                                  : null
                              }
                              readOnly
                              viewRenderers={{
                                hours: renderTimeViewClock,
                                minutes: renderTimeViewClock,
                                seconds: renderTimeViewClock,
                              }}
                              slotProps={{
                                textField: {
                                  size: "small",
                                  variant: "outlined",
                                },
                              }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: commonCss.inputBorderRadius,
                                  backgroundColor: commonCss.readOnlyBGColor,
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: commonCss.inputBorderColor,
                                },
                              }}
                              fullWidth
                            />
                          </DemoItem>
                        </LocalizationProvider>
                      </Grid2>
                      <Grid2 container size={12} justifyContent={"center"}>
                        <Button
                          variant="contained"
                          type="button"
                          sx={{
                            backgroundColor: commonCss.red,
                            borderRadius: commonCss.buttonBorderRadius,
                            textTransform: "none",
                            padding: "0.6rem 1rem",
                            color: commonCss.buttonTextColor,
                            width: "15vw",
                            display: roleAccess.engineerCancel
                              ? "none"
                              : "default",
                          }}
                          onClick={() => {
                            setRemarkButton({ ...remarkButton, cancel: true });
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          type="button"
                          variant="contained"
                          // disabled={values.isEngineerApproved}
                          sx={{
                            backgroundColor: commonCss.red,
                            borderRadius: commonCss.buttonBorderRadius,
                            textTransform: "none",
                            padding: "0.6rem 1rem",
                            color: commonCss.buttonTextColor,
                            width: "15vw",
                            display: roleAccess.engineer ? "none" : "default",
                          }}
                          onClick={() => {
                            setRemarkButton({ ...remarkButton, reject: true });
                          }}
                        >
                          Amend
                        </Button>
                        <Button
                          type="submit"
                          variant="contained"
                          // disabled={values.isEngineerApproved}
                          sx={{
                            backgroundColor: commonCss.green,
                            borderRadius: commonCss.buttonBorderRadius,
                            textTransform: "none",
                            padding: "0.6rem 1rem",
                            color: commonCss.buttonTextColor,
                            width: "15vw",
                            display: roleAccess.engineer ? "none" : "default",
                          }}
                          // onClick={() => {
                          //   setFieldValue("isEngineerApproved", true);
                          //   setFieldValue("engineerId", login.userId);
                          //   setFieldValue(
                          //     "engineerApprovedDate",
                          //     moment().format("YYYY-MM-DDTHH:mm:ss")
                          //   );
                          //   setApproveInfo({
                          //     ...approveInfo,
                          //     engineerName:
                          //       login.firstName + " " + login.lastName,
                          //   });
                          // }}
                        >
                          Acknowledge
                        </Button>
                      </Grid2>
                    </Grid2>
                  </Paper>
                </Grid2>
                <Grid2 container size={{ xs: 12, md: 4 }}>
                  <Paper
                    elevation={3}
                    sx={{
                      borderRadius: commonCss.paperBorderRadius,
                      p: 1.5,
                      background: "white",
                      width: "100%",
                    }}
                  >
                    <Grid2 container size={12} spacing={"1rem"}>
                      <Grid2 size={12}>
                        <Typography
                          variant="body2"
                          fontWeight={commonCss.mainLabelHeading}
                          color={commonCss.blue}
                          textAlign={"center"}
                        >
                          LPI
                        </Typography>
                        <Divider
                          sx={{
                            borderColor: commonCss.darkBlue,
                            borderWidth: 1,
                            width: "100%",
                            mt: 1,
                          }}
                        />
                      </Grid2>
                      <Grid2 size={12}>
                        <Typography
                          variant="body2"
                          fontWeight={commonCss.normalSentenceWeight}
                          color={commonCss.normalSenternceColor}
                          sx={{ textTransform: "none" }}
                        >
                          Isolation Certificate is described in the permit to
                          work is allowed between:
                        </Typography>
                      </Grid2>
                      <Grid2 size={{ xs: 12 }}>
                        <InputLabel>
                          <Typography
                            variant="body2"
                            fontWeight={commonCss.labelFontWeight}
                            color={commonCss.labelInputColor}
                          >
                            Name
                          </Typography>
                        </InputLabel>
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          value={approveInfo.lpiName}
                          slotProps={{
                            input: {
                              readOnly: true, // Set readOnly to true
                            },
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              backgroundColor: commonCss.readOnlyBGColor,
                              borderRadius: commonCss.inputBorderRadius,
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: commonCss.inputBorderColor,
                            },
                          }}
                        />
                      </Grid2>
                      <Grid2 size={{ xs: 12 }}>
                        <InputLabel>
                          <Typography
                            variant="body2"
                            fontWeight={commonCss.labelFontWeight}
                            color={commonCss.labelInputColor}
                          >
                            Date/Time
                          </Typography>
                        </InputLabel>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoItem>
                            <DateTimePicker
                              ampm={false}
                              readOnly
                              value={
                                values.isLPIApproved
                                  ? dayjs(values.lpiApprovedDate)
                                  : null
                              }
                              format="DD/MM/YYYY HH:mm"
                              viewRenderers={{
                                hours: renderTimeViewClock,
                                minutes: renderTimeViewClock,
                                seconds: renderTimeViewClock,
                              }}
                              slotProps={{
                                textField: {
                                  size: "small",
                                  variant: "outlined",
                                },
                              }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: commonCss.inputBorderRadius,
                                  backgroundColor: commonCss.readOnlyBGColor,
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: commonCss.inputBorderColor,
                                },
                              }}
                              fullWidth
                            />
                          </DemoItem>
                        </LocalizationProvider>
                      </Grid2>
                      <Grid2 size={{ xs: 12 }}>
                        <InputLabel>
                          <Typography
                            variant="body2"
                            fontWeight={commonCss.labelFontWeight}
                            color={commonCss.labelInputColor}
                          >
                            From
                          </Typography>
                        </InputLabel>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoItem>
                            <DatePicker
                              ampm={false}
                              format="DD/MM/YYYY"
                              readOnly={roleAccess.lpi}
                              minDate={
                                approvedData.isLeadPermitIssuerApproved
                                  ? dayjs(approvedData.lpiPermitValidFrom)
                                  : approvedData.isPermitIssuerApproved
                                    ? dayjs(approvedData.piPermitValidFrom)
                                    : dayjs(moment())
                              }
                              maxDate={
                                approvedData.isLeadPermitIssuerApproved
                                  ? dayjs(approvedData.lpiPermitValidUpTo)
                                  : approvedData.isPermitIssuerApproved
                                    ? dayjs(approvedData.piPermitValidUpTo)
                                    : undefined
                              }
                              value={
                                values.certificateValidFrom !== null
                                  ? dayjs(values.certificateValidFrom)
                                  : null
                              }
                              slotProps={{
                                textField: {
                                  size: "small",
                                  variant: "outlined",
                                },
                              }}
                              onChange={(newValue) => {
                                console.log(newValue);
                                if (newValue !== null) {
                                  if (`${newValue.$d}` !== "Invalid Date") {
                                    // const dateFrom = moment(newValue.$d).format(
                                    //   "YYYY-MM-DD"
                                    // );

                                    // const hour =
                                    //   new Date().getHours() < 10
                                    //     ? "0" + new Date().getHours()
                                    //     : new Date().getHours();
                                    // const min =
                                    //   new Date().getMinutes() < 10
                                    //     ? "0" + new Date().getMinutes()
                                    //     : new Date().getMinutes();
                                    // const sec =
                                    //   new Date().getSeconds() < 10
                                    //     ? "0" + new Date().getSeconds()
                                    //     : new Date().getSeconds();
                                    // const dateFormat =
                                    //   dateFrom +
                                    //   "T" +
                                    //   hour +
                                    //   ":" +
                                    //   min +
                                    //   ":" +
                                    //   sec +
                                    //   "Z";
                                    const dateFrom =
                                      moment(newValue.$d).format("YYYY-MM-DD") +
                                      "T00:00:00Z";
                                    setFieldValue(
                                      "certificateValidFrom",
                                      dateFrom,
                                    );

                                    // const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                                    // const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                                    // const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                                    // const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                                    // setFieldValue("installationDate", dateFormat);
                                  }
                                }
                              }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: commonCss.inputBorderRadius,
                                  backgroundColor: roleAccess.lpi
                                    ? commonCss.readOnlyBGColor
                                    : commonCss.inputBackgroundColor,
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: commonCss.inputBorderColor,
                                },
                              }}
                              fullWidth
                            />
                          </DemoItem>
                        </LocalizationProvider>
                      </Grid2>
                      <Grid2 size={{ xs: 12 }}>
                        <InputLabel>
                          <Typography
                            variant="body2"
                            fontWeight={commonCss.labelFontWeight}
                            color={commonCss.labelInputColor}
                          >
                            Until
                          </Typography>
                        </InputLabel>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoItem>
                            <DatePicker
                              ampm={false}
                              format="DD/MM/YYYY"
                              readOnly={roleAccess.lpi}
                              minDate={
                                approvedData.isLeadPermitIssuerApproved
                                  ? dayjs(approvedData.lpiPermitValidFrom)
                                  : approvedData.isPermitIssuerApproved
                                    ? dayjs(approvedData.piPermitValidFrom)
                                    : dayjs(moment())
                              }
                              maxDate={
                                approvedData.isLeadPermitIssuerApproved
                                  ? dayjs(approvedData.lpiPermitValidUpTo)
                                  : approvedData.isPermitIssuerApproved
                                    ? dayjs(approvedData.piPermitValidUpTo)
                                    : undefined
                              }
                              value={
                                values.certificateValidTo !== null
                                  ? dayjs(values.certificateValidTo)
                                  : null
                              }
                              slotProps={{
                                textField: {
                                  size: "small",
                                  variant: "outlined",
                                },
                              }}
                              onChange={(newValue) => {
                                console.log(newValue);
                                if (newValue !== null) {
                                  if (`${newValue.$d}` !== "Invalid Date") {
                                    // const dateFrom = moment(newValue.$d).format(
                                    //   "YYYY-MM-DD"
                                    // );

                                    // const hour =
                                    //   new Date().getHours() < 10
                                    //     ? "0" + new Date().getHours()
                                    //     : new Date().getHours();
                                    // const min =
                                    //   new Date().getMinutes() < 10
                                    //     ? "0" + new Date().getMinutes()
                                    //     : new Date().getMinutes();
                                    // const sec =
                                    //   new Date().getSeconds() < 10
                                    //     ? "0" + new Date().getSeconds()
                                    //     : new Date().getSeconds();
                                    // const dateFormat =
                                    //   dateFrom +
                                    //   "T" +
                                    //   hour +
                                    //   ":" +
                                    //   min +
                                    //   ":" +
                                    //   sec +
                                    //   "Z";
                                    const dateFrom =
                                      moment(newValue.$d).format("YYYY-MM-DD") +
                                      "T00:00:00Z";
                                    setFieldValue(
                                      "certificateValidTo",
                                      dateFrom,
                                    );

                                    // const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                                    // const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                                    // const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                                    // const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                                    // setFieldValue("installationDate", dateFormat);
                                  }
                                }
                              }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: commonCss.inputBorderRadius,
                                  backgroundColor: roleAccess.lpi
                                    ? commonCss.readOnlyBGColor
                                    : commonCss.inputBackgroundColor,
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: commonCss.inputBorderColor,
                                },
                              }}
                              fullWidth
                            />
                          </DemoItem>
                        </LocalizationProvider>
                      </Grid2>
                      <Grid2
                        container
                        size={12}
                        justifyContent={"center"}
                        sx={{ display: roleAccess.lpi ? "none" : "default" }}
                      >
                        <Button
                          variant="contained"
                          type="button"
                          sx={{
                            backgroundColor: commonCss.red,
                            borderRadius: commonCss.buttonBorderRadius,
                            textTransform: "none",
                            padding: "0.6rem 1rem",
                            color: commonCss.buttonTextColor,
                            width: "15vw",
                            display: roleAccess.lpiCancel ? "none" : "default",
                          }}
                          onClick={() => {
                            setRemarkButton({ ...remarkButton, cancel: true });
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          type="button"
                          variant="contained"
                          disabled={values.isLPIApproved}
                          sx={{
                            backgroundColor: commonCss.red,
                            borderRadius: commonCss.buttonBorderRadius,
                            textTransform: "none",
                            padding: "0.6rem 1rem",
                            color: commonCss.buttonTextColor,
                            width: "15vw",
                            display: roleAccess.lpi ? "none" : "default",
                          }}
                          onClick={() => {
                            setRemarkButton({ ...remarkButton, reject: true });
                          }}
                        >
                          Reject
                        </Button>
                        <Button
                          type="submit"
                          variant="contained"
                          disabled={values.isLPIApproved}
                          sx={{
                            backgroundColor: commonCss.green,
                            borderRadius: commonCss.buttonBorderRadius,
                            textTransform: "none",
                            padding: "0.6rem 1rem",
                            color: commonCss.buttonTextColor,
                            width: "15vw",
                            display: roleAccess.lpi ? "none" : "default",
                          }}
                          // onClick={() => {
                          //   setFieldValue("isLPIApproved", true);
                          //   setFieldValue("lpiId", login.userId);
                          //   setFieldValue(
                          //     "lpiApprovedDate",
                          //     moment().format("YYYY-MM-DDTHH:mm:ss")
                          //   );
                          //   setApproveInfo({
                          //     ...approveInfo,
                          //     lpiName: login.firstName + " " + login.lastName,
                          //   });
                          // }}
                        >
                          Approve
                        </Button>
                      </Grid2>
                    </Grid2>
                  </Paper>
                </Grid2>
                <Grid2 container size={{ xs: 12, md: 4 }}>
                  <Paper
                    elevation={3}
                    sx={{
                      borderRadius: commonCss.paperBorderRadius,
                      p: 1.5,
                      background: "white",
                      width: "100%",
                    }}
                  >
                    <Grid2 container size={12} spacing={"1rem"}>
                      <Grid2 item xs={12}>
                        <Typography
                          variant="body2"
                          fontWeight={commonCss.normalSentenceWeight}
                          color={commonCss.normalSenternceColor}
                          sx={{ textTransform: "none" }}
                        >
                          Isolation Certificate is certificate and permit to
                          work are withdrawn:
                        </Typography>
                      </Grid2>
                      <Grid2 size={{ xs: 12 }}>
                        <InputLabel>
                          <Typography
                            variant="body2"
                            fontWeight={commonCss.labelFontWeight}
                            color={commonCss.labelInputColor}
                          >
                            Permit Holder Name
                          </Typography>
                        </InputLabel>
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          slotProps={{
                            input: {
                              readOnly: true,
                            },
                          }}
                          value={
                            values.isPHCertificateClosed !== null
                              ? approveInfo.certificateClosedName
                              : null
                          }
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              backgroundColor: commonCss.readOnlyBGColor,
                              borderRadius: commonCss.inputBorderRadius,
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: commonCss.inputBorderColor,
                            },
                          }}
                        />
                      </Grid2>
                      <Grid2 size={{ xs: 12 }}>
                        <InputLabel>
                          <Typography
                            variant="body2"
                            fontWeight={commonCss.labelFontWeight}
                            color={commonCss.labelInputColor}
                          >
                            Permit Holder Date/Time
                          </Typography>
                        </InputLabel>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoItem>
                            <DateTimePicker
                              ampm={false}
                              format="DD/MM/YYYY HH:mm"
                              readOnly
                              value={
                                values.isPHCertificateClosed
                                  ? dayjs(values.phCertificateClosedAt)
                                  : null
                              }
                              viewRenderers={{
                                hours: renderTimeViewClock,
                                minutes: renderTimeViewClock,
                                seconds: renderTimeViewClock,
                              }}
                              slotProps={{
                                textField: {
                                  size: "small",
                                  variant: "outlined",
                                },
                              }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: commonCss.inputBorderRadius,
                                  backgroundColor: commonCss.readOnlyBGColor,
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: commonCss.inputBorderColor,
                                },
                              }}
                              fullWidth
                            />
                          </DemoItem>
                        </LocalizationProvider>
                      </Grid2>
                      <Grid2 size={{ xs: 12 }}>
                        <InputLabel>
                          <Typography
                            variant="body2"
                            fontWeight={commonCss.labelFontWeight}
                            color={commonCss.labelInputColor}
                          >
                            Permit Holder Reason
                          </Typography>
                        </InputLabel>
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          name="reason"
                          value={closedRemark.PH}
                          slotProps={{
                            input: {
                              readOnly: roleAccess.certClose,
                            },
                          }}
                          onChange={(e) => {
                            setClosedRemark({
                              ...closedRemark,
                              PH: e.target.value,
                            });
                          }}
                          multiline
                          minRows={2}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              backgroundColor: roleAccess.certClose
                                ? commonCss.readOnlyBGColor
                                : commonCss.inputBackgroundColor,
                              borderRadius: commonCss.inputBorderRadius,
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: commonCss.inputBorderColor,
                            },
                          }}
                        />
                      </Grid2>
                      <Grid2 size={12}>
                        {/* <InputLabel>
                          <Typography
                            variant="body2"
                            fontWeight={commonCss.labelFontWeight}
                            color={commonCss.labelInputColor}
                          >
                            Is this deisolate?
                          </Typography>
                        </InputLabel> */}
                        {/* <Box sx={{display:"flex",gap:"0.6rem",justifyContent:"center",alignItems:"center",width:"100%"}}>
                     
                  <FormControlLabel
                   
                   sx={{"& .MuiFormControlLabel-label.Mui-disabled":{
                 
                 color:"black"
                 
                }}}
                   control={
                     <Checkbox
                     checked={!deisolationBol}
                     disabled={roleAccess.certClose}
                     onClick={(e)=>{setDeisolationBol(e.target.checked)}}
                       sx={{
                         "& .MuiSvgIcon-root": {
                           fill: "rgb(0, 86, 151)",
                         },
                         "&:checked": {
                           color: "rgb(0, 86, 151)",
                         },
                         
                       }}
                     />
                   }
                   label={"No"}
                 />
                  </Box> */}
                        <FormControlLabel
                          sx={{
                            "& .MuiFormControlLabel-label.Mui-disabled": {
                              color: "black",
                            },
                          }}
                          control={
                            <Checkbox
                              checked={deisolationBol}
                              disabled={roleAccess.certClose}
                              onClick={(e) => {
                                setDeisolationBol(e.target.checked);
                              }}
                              sx={{
                                "& .MuiSvgIcon-root": {
                                  fill: "rgb(0, 86, 151)",
                                },
                                "&:checked": {
                                  color: "rgb(0, 86, 151)",
                                },
                              }}
                            />
                          }
                          label={"Is This Deisolate?"}
                        />
                      </Grid2>
                      <Grid2 container size={12} justifyContent={"center"}>
                        <Button
                          variant="contained"
                          disabled={values.isPHCertificateClosed}
                          sx={{
                            backgroundColor: "rgb(0, 86, 151)",
                            borderRadius: commonCss.buttonBorderRadius,
                            textTransform: "none",
                            padding: "0.6rem 1rem",
                            color: commonCss.buttonTextColor,
                            width: "15vw",
                            display: roleAccess.certClose ? "none" : "default",
                          }}
                          onClick={() => {
                            setConfirm({ ...confirm, close: true });
                          }}
                        >
                          Close
                        </Button>
                      </Grid2>
                      <Grid2
                        container
                        size={12}
                        justifyContent={"center"}
                        sx={{
                          display: values.isPHCertificateClosed
                            ? "default"
                            : "none",
                        }}
                      >
                        <Grid2 size={{ xs: 12 }}>
                          <InputLabel>
                            <Typography
                              variant="body2"
                              fontWeight={commonCss.labelFontWeight}
                              color={commonCss.labelInputColor}
                            >
                              LPI Name
                            </Typography>
                          </InputLabel>
                          {/* <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            slotProps={{
                              input: {
                                readOnly: true,
                              },
                            }}
                            value={
                              values.isLPICertificateClosed !== null
                                ? approveInfo.lpiCertClosedName
                                : null
                            }
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                backgroundColor: commonCss.readOnlyBGColor,
                                borderRadius: commonCss.inputBorderRadius,
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: commonCss.inputBorderColor,
                              },
                            }}
                          /> */}
                          <Autocomplete
                            readOnly={roleAccess.lpiCertClose}
                            name="lpiId"
                            inputValue={lpi.lpiCom}
                            value={{
                              id: lpi.lpiId,
                              firstName: "",
                              lastName: "",
                            }}
                            // filterOptions={filterOptions}
                            loading={lpiData.length === 0}
                            options={lpiData}
                            // PaperComponent={CustomPaper}
                            getOptionLabel={(option) =>
                              option.firstName + " " + option.lastName || option
                            }
                            getOptionDisabled={(option) =>
                              certificateInfo.lpiId === option.id
                            }
                            onChange={(event, value) => {
                              if (value) {
                                setFieldValue("lpiId", value.id);
                                setLPI({
                                  ...lpi,
                                  lpiCom:
                                    value.firstName + " " + value.lastName,
                                  lpiId: value.id,
                                });
                              } else {
                                setFieldValue("lpiId", null);
                                setLPI({ ...lpi, lpiCom: "", lpiId: null });
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                name="lpiId"
                                size="small"
                                // variant="standard"
                                onChange={(e) => {
                                  setLPI({ ...lpi, lpiCom: e.target.value });
                                }}
                                // slotProps={{
                                //   input:{
                                //     readOnly:roleAccess.contractStaff
                                //   }
                                // }}
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    backgroundColor: roleAccess.lpiCertClose
                                      ? commonCss.readOnlyBGColor
                                      : commonCss.inputBackgroundColor,
                                    borderRadius: commonCss.inputBorderRadius,
                                  },
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: commonCss.inputBorderColor,
                                  },
                                }}
                                // onBlur={() => setFieldTouched("agtId", true)}
                              />
                            )}
                          />
                        </Grid2>
                        <Grid2 size={{ xs: 12 }}>
                          <InputLabel>
                            <Typography
                              variant="body2"
                              fontWeight={commonCss.labelFontWeight}
                              color={commonCss.labelInputColor}
                            >
                              LPI Date/Time
                            </Typography>
                          </InputLabel>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoItem>
                              <DateTimePicker
                                ampm={false}
                                format="DD/MM/YYYY HH:mm"
                                readOnly
                                value={
                                  values.isLPICertificateClosed
                                    ? dayjs(values.lpiCertificateClosedAt)
                                    : null
                                }
                                viewRenderers={{
                                  hours: renderTimeViewClock,
                                  minutes: renderTimeViewClock,
                                  seconds: renderTimeViewClock,
                                }}
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    variant: "outlined",
                                  },
                                }}
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    borderRadius: commonCss.inputBorderRadius,
                                    backgroundColor: commonCss.readOnlyBGColor,
                                  },
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: commonCss.inputBorderColor,
                                  },
                                }}
                                fullWidth
                              />
                            </DemoItem>
                          </LocalizationProvider>
                        </Grid2>
                        <Grid2 size={{ xs: 12 }}>
                          <InputLabel>
                            <Typography
                              variant="body2"
                              fontWeight={commonCss.labelFontWeight}
                              color={commonCss.labelInputColor}
                            >
                              Reason
                            </Typography>
                          </InputLabel>
                          <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            name="reason"
                            value={closedRemark.LPI}
                            slotProps={{
                              input: {
                                readOnly: roleAccess.lpiCertCloseReason,
                              },
                            }}
                            onChange={(e) => {
                              setClosedRemark({
                                ...closedRemark,
                                LPI: e.target.value,
                              });
                            }}
                            multiline
                            minRows={2}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                backgroundColor: roleAccess.lpiCertCloseReason
                                  ? commonCss.readOnlyBGColor
                                  : commonCss.inputBackgroundColor,
                                borderRadius: commonCss.inputBorderRadius,
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: commonCss.inputBorderColor,
                              },
                            }}
                          />
                        </Grid2>
                        <Grid2 container size={12} justifyContent={"center"}>
                          <Button
                            variant="contained"
                            sx={{
                              backgroundColor: commonCss.blue,
                              borderRadius: commonCss.buttonBorderRadius,
                              textTransform: "none",
                              padding: "0.6rem 1rem",
                              color: commonCss.buttonTextColor,
                              width: "15vw",
                              display: roleAccess.lpiCertClose
                                ? "none"
                                : "default",
                            }}
                            onClick={() => {
                              setConfirm({ ...confirm, reAssign: true });
                              setConfirmValue([values, "lpi"]);
                            }}
                          >
                            Reassign
                          </Button>
                          <Button
                            variant="contained"
                            disabled={values.isLPICertificateClosed}
                            sx={{
                              backgroundColor: "rgb(0, 86, 151)",
                              borderRadius: commonCss.buttonBorderRadius,
                              textTransform: "none",
                              padding: "0.6rem 1rem",
                              color: commonCss.buttonTextColor,
                              width: "15vw",
                              display: roleAccess.lpiCertCloseReason
                                ? "none"
                                : "default",
                            }}
                            onClick={() => {
                              setConfirm({ ...confirm, close: true });
                            }}
                          >
                            Close
                          </Button>
                        </Grid2>
                      </Grid2>
                    </Grid2>
                  </Paper>
                </Grid2>
                <Grid2 container size={12}>
                  <Paper
                    elevation={3}
                    sx={{
                      borderRadius: commonCss.paperBorderRadius,
                      p: 1.5,
                      background: "white",
                      width: "100%",
                    }}
                  >
                    <Grid2 container spacing={2} mb={2}>
                      <Typography
                        variant="body2"
                        fontWeight={commonCss.normalSentenceWeight}
                        color={commonCss.normalSenternceColor}
                        sx={{ textTransform: "none" }}
                      >
                        I have personally checked the equipment isolated above
                        and confirm that work on it is completed and said
                        equipment has been re-connected and is in a safe working
                        condition.
                      </Typography>
                    </Grid2>
                    <Grid2 size={12}>
                      <NormalTableWithRadius
                        data={reconnectionData}
                        columns={reconnectionColumns}
                      />
                    </Grid2>
                    {/* <Grid2
                      container
                      spacing={2}
                      mb={2}
                      justifyContent={"flex-end"}
                      sx={{
                        display: roleAccess.technician ? "none" : "default",
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{
                          width: "15vw",
                          backgroundColor: "#FF0000",
                          color: "white",
                          borderRadius: "10px",
                          "&:hover": {
                            backgroundColor: "#cc0000",
                          },
                          mt: 2,
                        }}
                        onClick={() => {
                          setConfirm({ ...confirm, deIsolationFalse: true });
                          setConfirmValue([false]);
                        }}
                      >
                        Reconnection
                      </Button>
                    </Grid2> */}
                  </Paper>
                </Grid2>
                <Grid2
                  container
                  size={12}
                  justifyContent={"flex-end"}
                  //  sx={{ display: roleAccess.submitButton && !certificateInfo.isCancel===true ? "default" : "none" }}
                >
                  <Button
                    variant="contained"
                    type="button"
                    sx={{
                      backgroundColor: commonCss.red,
                      borderRadius: commonCss.buttonBorderRadius,
                      textTransform: "none",
                      padding: "0.6rem 1rem",
                      color: commonCss.buttonTextColor,
                      width: "10vw",
                      display: roleAccess.adminCancelButton
                        ? "default"
                        : "none",
                    }}
                    onClick={() => {
                      setRemarkButton({ ...remarkButton, adminCancel: true });
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    type="submit"
                    sx={{
                      backgroundColor: commonCss.green,
                      borderRadius: commonCss.buttonBorderRadius,
                      textTransform: "none",
                      padding: "0.6rem 1rem",
                      color: commonCss.buttonTextColor,
                      width: "10vw",
                      //    display: roleAccess.submitButton && !certificateInfo.isCancel===true ? "default" : "none"
                      display:
                        activeTab === 0 &&
                        (roleAccess.submitButton ||
                          approvedData.formStatus === 11) &&
                        !certificateInfo.isCancel &&
                        roleName !== roleNameString.admin // ✅ hide when isCancel = true
                          ? "default"
                          : "none",
                      //  display:
                      //         roleAccess.submitButton &&
                      //           (certificateInfo.isLeadPermitIssuerApproved === true || certificateInfo.isLeadPermitIssuerApproved === null) &&
                      //           !certificateInfo.isCancel
                      //           ? "default"
                      //           : "none",
                    }}
                  >
                    Submit
                  </Button>
                </Grid2>
              </Grid2>
              <Dialog
                // maxWidth={"lg"}
                open={remarkButton.reject}
                onClose={() => {
                  setRemarkButton({ ...remarkButton, reject: false });
                }}
                maxWidth="md"
                fullWidth
                PaperProps={{
                  sx: {
                    background: "rgb(0, 86, 151)",
                    borderRadius: "10px",
                  },
                }}
              >
                <DialogContent>
                  <Remark
                    handleSubmitRemark={(e) => {
                      handleReject(values, e);
                    }}
                    handleCloseClick={() => {
                      setRemarkButton({ ...remarkButton, reject: false });
                    }}
                  />
                </DialogContent>
              </Dialog>
              <Dialog
                // maxWidth={"lg"}
                open={confirm.submit}
                onClose={() => {
                  setConfirm({ ...confirm, submit: false });
                }}
                maxWidth={"md"}
                PaperProps={{
                  sx: {
                    background: "rgb(0, 86, 151)",
                    borderRadius: "10px",
                  },
                }}
              >
                <DialogContent>
                  <Confirmation
                    onSubmit={() => {
                      onApproveAndSubmit(...confirmValue);
                    }}
                    name={"submit"}
                    handleCloseClick={() => {
                      setConfirm({ ...confirm, submit: false });
                      setConfirmValue([]);
                    }}
                  />
                </DialogContent>
              </Dialog>
              <Dialog
                // maxWidth={"lg"}
                open={confirm.close}
                onClose={() => {
                  setConfirm({ ...confirm, close: false });
                }}
                maxWidth={"md"}
                PaperProps={{
                  sx: {
                    background: "rgb(0, 86, 151)",
                    borderRadius: "10px",
                  },
                }}
              >
                <DialogContent>
                  <Confirmation
                    onSubmit={() => {
                      handleCloseCertificate();
                    }}
                    name={"close"}
                    handleCloseClick={() => {
                      setConfirm({ ...confirm, close: false });
                      setConfirmValue([]);
                    }}
                  />
                </DialogContent>
              </Dialog>
              <Dialog
                // maxWidth={"lg"}
                open={confirm.deIsolationTrue}
                onClose={() => {
                  setConfirm({ ...confirm, deIsolationTrue: false });
                }}
                maxWidth={"md"}
                PaperProps={{
                  sx: {
                    background: "rgb(0, 86, 151)",
                    borderRadius: "10px",
                  },
                }}
              >
                <DialogContent>
                  <Confirmation
                    onSubmit={() => {
                      handleReconnection();
                    }}
                    name={"submit"}
                    handleCloseClick={() => {
                      setConfirm({ ...confirm, deIsolationTrue: false });
                      setConfirmValue([]);
                    }}
                  />
                </DialogContent>
              </Dialog>
              <Dialog
                // maxWidth={"lg"}
                open={confirm.deIsolationFalse}
                onClose={() => {
                  setConfirm({ ...confirm, deIsolationFalse: false });
                }}
                maxWidth={"md"}
                PaperProps={{
                  sx: {
                    background: "rgb(0, 86, 151)",
                    borderRadius: "10px",
                  },
                }}
              >
                <DialogContent>
                  <Confirmation
                    onSubmit={() => {
                      handleDeisolationButton(...confirmValue);
                    }}
                    name={"submit"}
                    handleCloseClick={() => {
                      setConfirm({ ...confirm, deIsolationFalse: false });
                      setConfirmValue([]);
                    }}
                  />
                </DialogContent>
              </Dialog>
              <Dialog
                // maxWidth={"lg"}
                open={confirm.ioivApprove}
                onClose={() => {
                  setConfirm({ ...confirm, ioivApprove: false });
                }}
                maxWidth={"md"}
                PaperProps={{
                  sx: {
                    background: "rgb(0, 86, 151)",
                    borderRadius: "10px",
                  },
                }}
              >
                <DialogContent>
                  <Confirmation
                    onSubmit={() => {
                      handleIsolation(...confirmValue);
                    }}
                    name={"submit"}
                    handleCloseClick={() => {
                      setConfirm({ ...confirm, ioivApprove: false });
                      setConfirmValue([]);
                    }}
                  />
                </DialogContent>
              </Dialog>
              <Dialog
                // maxWidth={"lg"}
                open={confirm.ioivReassign}
                onClose={() => {
                  setConfirm({ ...confirm, ioivReassign: false });
                }}
                maxWidth={"md"}
                PaperProps={{
                  sx: {
                    background: "rgb(0, 86, 151)",
                    borderRadius: "10px",
                  },
                }}
              >
                <DialogContent>
                  <Confirmation
                    onSubmit={() => {
                      handleIsolationReassign(...confirmValue);
                    }}
                    name={"submit"}
                    handleCloseClick={() => {
                      setConfirm({ ...confirm, ioivReassign: false });
                      setConfirmValue([]);
                    }}
                  />
                </DialogContent>
              </Dialog>
              <Dialog
                // maxWidth={"lg"}
                open={confirm.ioivReassignReconnection}
                onClose={() => {
                  setConfirm({ ...confirm, ioivReassignReconnection: false });
                }}
                maxWidth={"md"}
                PaperProps={{
                  sx: {
                    background: "rgb(0, 86, 151)",
                    borderRadius: "10px",
                  },
                }}
              >
                <DialogContent>
                  <Confirmation
                    onSubmit={() => {
                      handleIsolationReassignInReconnection(...confirmValue);
                    }}
                    name={"submit"}
                    handleCloseClick={() => {
                      setConfirm({
                        ...confirm,
                        ioivReassignReconnection: false,
                      });
                      setConfirmValue([]);
                    }}
                  />
                </DialogContent>
              </Dialog>
              <Dialog
                open={confirm.deleteAttach}
                onClose={() => setConfirm({ ...confirm, deleteAttach: false })}
                maxWidth={"md"}
                PaperProps={{
                  sx: { background: "rgb(0, 86, 151)", borderRadius: "10px" },
                }}
              >
                <DialogContent>
                  <Confirmation
                    onSubmit={() => handleDeleteAttach(...confirmValue)}
                    name={"delete"}
                    handleCloseClick={() => {
                      setConfirm({ ...confirm, deleteAttach: false });
                      setConfirmValue([]);
                    }}
                  />
                </DialogContent>
              </Dialog>
              <Dialog
                // maxWidth={"lg"}
                open={remarkButton.cancel}
                onClose={() => {
                  setRemarkButton({ ...remarkButton, cancel: false });
                }}
                maxWidth="md"
                fullWidth
                PaperProps={{
                  sx: {
                    background: "rgb(0, 86, 151)",
                    borderRadius: "10px",
                  },
                }}
              >
                <DialogContent>
                  <Remark
                    handleSubmitRemark={(e) => {
                      handleCancel(values, e);
                    }}
                    handleCloseClick={() => {
                      setRemarkButton({ ...remarkButton, cancel: false });
                    }}
                  />
                </DialogContent>
              </Dialog>
              <Dialog
                // maxWidth={"lg"}
                open={confirm.reAssign}
                onClose={() => {
                  setConfirm({ ...confirm, reAssign: false });
                }}
                maxWidth={"md"}
                PaperProps={{
                  sx: {
                    background: "rgb(0, 86, 151)",
                    borderRadius: "10px",
                  },
                }}
              >
                <DialogContent>
                  <Confirmation
                    onSubmit={() => {
                      onReassign(...confirmValue);
                    }}
                    name={"reassign"}
                    handleCloseClick={() => {
                      setConfirm({ ...confirm, reAssign: false });
                      setConfirmValue([]);
                    }}
                  />
                </DialogContent>
              </Dialog>
              <Dialog
                // maxWidth={"lg"}
                open={remarkButton.adminCancel}
                onClose={() => {
                  setRemarkButton({ ...remarkButton, adminCancel: false });
                }}
                maxWidth="md"
                fullWidth
                PaperProps={{
                  sx: {
                    background: "rgb(0, 86, 151)",
                    borderRadius: "10px",
                  },
                }}
              >
                <DialogContent>
                  <Remark
                    handleSubmitRemark={(e) => {
                      handleCancel(values, e);
                    }}
                    handleCloseClick={() => {
                      setRemarkButton({ ...remarkButton, adminCancel: false });
                    }}
                  />
                </DialogContent>
              </Dialog>
            </Form>
          )}
        </Formik>
      ) : (
        <Loading color={commonCss.white} />
      )}
      <AuditLogDialog
        open={auditLogOpen}
        onClose={() => setAuditLogOpen(false)}
        data={certificateInfo.reassignAuditLogs}
        columns={auditLogColumns}
      />
    </>
  );
};

export default IsolationCertificate;
